const en = {
    common: {
        english: "English",
        spanish: "Spanish",
        french: "French",
        login: "Login",
        register: "Register",
        save: "Save",
        cancel: "Cancel",
        delete: "Delete",
        edit: "Edit",
        loading: "Loading...",
        language: "Language",
        divisions: "Divisions",
        seasons: "Seasons",
        season: "Season",
        teams: "Teams",
        players: "Players",
        referees: "Referees / Umpires",
        getStarted: "Get Started",
        learnMore: "Learn More",
        sending: "Sending...",
        backToLogin: "Back to Login",
        table: {
            subtitle: "Manage items in this list",
            add: "Add",
            prev: "Prev",
            next: "Next",
            page: "Page",
            of: "of"
        },
        previous: "Previous",
        next: "Next",
        collapse: "Collapse",
        expand: "Expand"
    },
    nav: {
        home: "Home",
        organizations: "Organizations",
        notifications: "Notifications",
        settings: "Settings",
        financial: "Financial",
        subscription: "Subscription",
        advertise: "Advertise",
    },
    marketplaceCategories: {
        "sports-equipment": "Sports equipment",
        "uniforms-apparel": "Uniforms and apparel",
        "team-equipment": "Team equipment",
        "facility-rentals": "Facility rentals",
        "training-equipment": "Training equipment",
        "coaching-services": "Coaching services",
        "officiating-services": "Officiating services",
        "sports-photography": "Sports photography",
        "equipment-repair": "Equipment repair",
        "tournament-services": "Tournament services",
    },
    marketplacePage: {
        title: "Marketplace",
        details: "Listing details",
        category: "Category",
        allCategories: "All categories",
        type: "Type",
        allTypes: "All types",
        sale: "For sale",
        rental: "For rent",
        city: "City",
        cityPlaceholder: "Search by city",
        search: "Search",
        searchPlaceholder: "Search by listing name or category",
        catalogSubtitle: "Browse listings from the sports community.",
        clearFilters: "Clear filters",
        noListings: "No listings found.",
        noImage: "No image",
        locationNotAvailable: "Location not available",
        pageOf: "Page {page} of {pages}",
        contactSeller: "Contact seller",
        favorite: "Save listing",
        favoriteUpdated: "Favorite updated.",
        conversationStarted: "Conversation started.",
        report: "Report",
        reportPrompt: "Tell us why you are reporting this listing.",
        reportSubmitted: "Report submitted.",
        rentalTerms: "Rental terms",
        seller: "Seller",
        sellerPrivateContact: "Contact details remain private until shared by the seller.",
        moreFromSeller: "More from this seller",
        blockSeller: "Block seller",
        confirmBlockSeller: "Block this seller? Their listings will no longer appear for you.",
        sellerBlocked: "Seller blocked.",
        blockedUsers: "Blocked marketplace users",
        blockedUsersDescription: "Manage sellers you have blocked. Their listings will not appear in your marketplace results.",
        blockedUserHint: "Their marketplace listings are hidden from you.",
        noBlockedUsers: "You have not blocked any marketplace users.",
        blockedSeller: "User {id}",
        unblock: "Unblock",
        safetyTitle: "Marketplace safety",
        safetyText: "Meet in public places, verify the item and transaction independently, and do not share unnecessary personal information. Payments, deposits, delivery, refunds, and rental disputes are arranged outside AngeonX Sports.",
    },
    marketplaceManagementPage: {
        title: "My listings",
        subtitle: "Manage your marketplace listings, images, rental terms, and promotion campaigns.",
        availableCredits: "Listing credits",
        enterpriseIncluded: "Included with Enterprise",
        listingUsage: "Listing usage",
        search: "Search listings",
        searchPlaceholder: "Search by listing name or category",
        statusFilter: "Listing status",
        allStatuses: "All",
        createListing: "Create listing",
        noListings: "You have not created any listings yet.",
        noImage: "No image",
        locationNotAvailable: "Location not available",
        view: "View",
        edit: "Edit",
        editTitle: "Edit listing",
        createTitle: "Create listing",
        saved: "Listing saved.",
        sections: {details: "Listing details", location: "Location", images: "Images"},
        fields: {title: "Title", type: "Type", condition: "Condition", description: "Description", category: "Category", sport: "Sport", price: "Price", currency: "Currency", city: "City", region: "Region", state: "State / Province", country: "Country", searchLocation: "Search location", locationPlaceholder: "Search for a city, region, or country", locationLoading: "Loading location search...", locationHint: "Select a Google Maps suggestion so the location details and coordinates are saved accurately.", primaryImage: "Primary image", imagesSelected: "images selected", imagesHint: "Select one or more images", rentalPrice: "Rental price", pricingPeriod: "Pricing period", hour: "Hour", day: "Day", week: "Week", month: "Month", minimumPeriod: "Minimum period", maximumPeriod: "Maximum period", depositRequired: "Deposit required", rentalTerms: "Rental terms"},
        imageDeleted: "Image deleted.",
        statusUpdated: "Listing status updated.",
        promote: "Promote listing",
        promotionTitle: "Promote listing",
        promotionName: "Campaign name",
        promotionSponsor: "Sponsor",
        promotionSelectSponsor: "Select a sponsor",
        promotionZones: "Ad placements",
        promotionSubmit: "Create promotion",
        promotionCreated: "Promotion draft created.",
        promotionStatus: "Promotion",
        managePromotion: "Manage promotion",
        promotionStatuses: {draft: "Draft", scheduled: "Scheduled", running: "Running", paused: "Paused"},
        promotionAlreadyExists: "This listing already has a promotion campaign. Opening it now.",
        promotionBudgetHint: "Next, complete the campaign dates, countries, currency, and targeting. The final budget is calculated using the current ad-zone rates at checkout.",
        promotionConfirmTitle: "Create promotion campaign?",
        promotionConfirmMessage: "A campaign draft will be created for {title}. You can review the dates, audience, and final payment requirement before activation.",
        promotionConfirmHint: "Enterprise league members may receive this promotion at no additional cost.",
        promotionConfirm: "Continue",
        promotionBadge: "PROMOTION",
        promotionNoSponsorTitle: "Create a sponsor profile first",
        promotionNoSponsorMessage: "A sponsor profile is required to create and manage an advertising campaign for this listing.",
        promotionCreateSponsor: "Create sponsor",
        actions: {updateStatus: "Update status", remove: "Remove listing", confirmStatus: "Change this listing to {{status}}?", confirmRemove: "Remove this listing?"},
        conditions: {new: "New", likeNew: "Like new", used: "Used", notApplicable: "Not applicable"},
        filters: {title: "Filter listings", subtitle: "Narrow the marketplace by type, condition, location, and price.", all: "All", listingType: "Listing type", condition: "Condition", status: "Status", category: "Category", sport: "Sport", city: "City", cityPlaceholder: "Enter city", region: "State / Province", regionPlaceholder: "Enter state or province", state: "State / Province", statePlaceholder: "Enter state or province", country: "Country", countryPlaceholder: "Enter country", minPrice: "Minimum price", maxPrice: "Maximum price", apply: "Apply filters"},
        statuses: {available: "Available", reserved: "Reserved", paused: "Paused", sold: "Sold", rented: "Rented", expired: "Expired", removed: "Removed"},
    },
    marketplaceModerationPage: {
        searchRank: "#", searchTerm: "Search", searches: "Searches", reportListing: "Listing", reportReason: "Reason", reportActions: "Actions",
        title: "Marketplace moderation",
        subtitle: "Review reports and manage marketplace listing visibility.",
        staffTools: "Staff tools",
        moderation: "Moderation",
        analyticsPeriod: "Analytics period",
        last7Days: "Last 7 days",
        last30Days: "Last 30 days",
        last90Days: "Last 90 days",
        allTime: "All time",
        allListings: "All listings",
        activeListings: "Active listings",
        hiddenListings: "Hidden listings",
        reports: "Reports",
        search: "Search listings",
        searchPlaceholder: "Search by listing name or category",
        filters: "Filters",
        filtersSubtitle: "Narrow listings by type, category, sport, or city.",
        listingType: "Listing type",
        category: "Category",
        sport: "Sport",
        city: "City",
        cityPlaceholder: "Enter city",
        all: "All",
        sale: "For sale",
        rental: "For rent",
        apply: "Apply filters",
        clear: "Clear filters",
        listings: "Marketplace listings",
        listingsSubtitle: "Review listing content and visibility.",
        noListings: "No listings found.",
        topSearches: "Top searches",
        topSearchesSubtitle: "Most common marketplace searches for the selected period.",
        noSearchActivity: "No search activity recorded.",
        pendingReports: "Pending reports",
        reportsSubtitle: "Review reports submitted by marketplace users.",
        noPendingReports: "No pending reports.",
        deletedListing: "Deleted listing",
        noDetails: "No details provided",
        dismiss: "Dismiss",
        markReviewed: "Mark reviewed",
        moderationUpdated: "Listing moderation updated.",
        unableToModerate: "Unable to moderate listing.",
        reportReviewed: "Report reviewed.",
        unableToReview: "Unable to review report.",
        staffRequired: "Staff access is required.",
        removalAction: "Moderation action",
        listing: "Listing",
        removeListing: "Remove listing",
        removalNotice: "This listing will be removed from marketplace search results. The seller will be notified.",
        removalReason: "Removal reason",
        removalPlaceholder: "Explain why this listing is being removed.",
        removalRequired: "A removal reason is required.",
        cancel: "Cancel",
        removing: "Removing...",
        removed: "Listing removed from the marketplace.",
        close: "Close",
        resolution: "Resolution:"
    },
    auth: {
        loginTitle: "Sign In",
        signingIn: "Signing in...",
        registerTitle: "Sign Up",
        forgotPassword: "Forgot password?",
        resendActivation: "Resend activation email",
        new: "New to kBola Sports?",
        signUpTitle: "Sign Up",
        didntReceived: "Didn&apos;t receive an activation email?",
        email: "Email",
        password: "Password",
        toast: {
            invalid: "Invalid credentials. Please try again. If the error persists contact AngeonX Sports Support."
        },
        title: "Sign in to start your session"
    },
    signUp: {
        titleManager: "Register a new manager and organization",
        addSponsor: "Register a new sponsor / advertiser",
        addAccount: "Register a new account",
        yourInfo: "Your Info",
        role: "I am signing up as:",
        orgInfo: "Organization Info",
        sponsorInfo: "Business / Sponsor Info",
        form: {
            firstName: "First Name",
            lastName: "Last Name",
            dob: "Date of birth",
            dobHint: "Used for age eligibility, divisions, and player verification.",
            gender: "Gender",
            genderNotSpecified: "Prefer not to say",
            genderMale: "Male",
            genderFemale: "Female",
            email: "Email",
            mobile: "Mobile",
            password: "Password",
            password2: "Retype Password",
            manager: "League / Academy Manager",
            sponsor: "Sponsor / Advertiser",
            orgType: "Organization Type",
            orgName: "Organization Name",
            sponsorName: "Business / Sponsor Name",
            website: "Website",
            contactName: "Contact Name",
            contactEmail: "Contact Email",
            sportAudience: "Primary Sport / Audience",
            orgLocation: "Where is your league/academy based?",
            orgLocationInfo: "We use this to show your organization in local search, maps, and Connect.",
            sponsorLocation: "Where is your business based?",
            sponsorLocationInfo: "We use this for local targeting (for example, show your promo to people near you).",
            yourLocation: "Your location",
            orgLabelLocation: "Location helps teams and players discover your league/academy.",
            sponsorLabelLocation: "Location helps us show your promo to nearby players and users.",
            agreeTo: "I agree to the",
            terms: "Terms",
            creatingLabel: "Creating account...",
            sports: {
                "american-football": "American football",
                baseball: "Baseball",
                basketball: "Basketball",
                hockey: "Hockey",
                rugby: "Rugby",
                soccer: "Soccer",
                softball: "Softball",
                volleyball: "Volleyball",
                multi: "Multiple / General Sports"
            },
            "player": "Player",
            "playerDescription": "Join teams, manage your profile, and participate in events.",
            "managerDescription": "Create leagues, academies, teams, schedules, and manage events.",
            "sponsorDescription": "Promote your business to sports communities and local audiences.",
            "locationInfo": "Location Information",
            "yourLocationInfo": "Your location helps us connect you with nearby teams, leagues, events, and sports opportunities.",
            "playerLabelLocation": "Used to connect you with nearby sports opportunities."
        },
        alreadyHaveAccount: "I already have an account",
        toast: {
            created: "Account created! Check your email to activate, then you can sign in.",
            error: "Something went wrong. Please try again later or contact AngeonX Sports support."
        }
    },
    resenActivation: {
        title: "Enter your email to resend activation link",
        status: "✅ Activation email has been sent successfully!",
        toast: {
            sent: "Activation email sent!",
            unknownError: "An unknown error occurred.",
            failed: "❌ Failed to resend activation email.",
            wrong: "⚠️ Something went wrong. Please try again.",
            error: "Error sending email. Try again later."
        }
    },
    forgotPassword: {
        title: "Enter your email to reset your password",
        button: "Send Reset Link"
    },
    policy: {
        title: "Terms of Service & Privacy Policy",
    },
    topBar: {
        passion: "Where Passion Meets Performance!",
        powerAi: "Smart Sports Management, Powered by AI",
        ourTech: "Your Game, your Technology!"
    },
    home: {
        hero: {
            title: "Welcome to",
            subtitle: "Official league portal. Track divisions, schedules, results and stats in one place.",
        },
        divisions: {
            noItems: "No divisions available yet.",
            open: "OPEN",
            closed: "CLOSED",
            seasonStart: "Season start",
            seasonEnd: "Season end",
        },
        upcomingGames: {
            title: "Upcoming Games",
            noItems: "No upcoming games scheduled.",
        },
        latestResults: {
            title: "Latest Results",
            noItems: "No results available yet."
        },
        game: {
            home: "Home",
            visitor: "Visitor",
            noPlay: "No play",
            final: "Final",
            noScore: "No score",
            field: "Field"
        },
        eventStatus: {
            draft: "Draft",
            scheduled: "Scheduled",
            in_progress: "In Progress",
            completed: "Completed",
            canceled: "Canceled",
            forfeit: "Forfeit",
            double_forfeit: "Double forfeit",
            extra: "Extra inning / time"
        },
        partners: {
            title: "Official Partners",
            subtitle: "Proudly supported by trusted organizations"
        },
        footer: {
            brandTitle: "Official portal on AngeonX Sports",
            terms: "Terms & Conditions",
            contact: "Contact",
            rights: "© {year} AngeonX Inc. All rights reserved.",
            angeonx: "AngeonX Sports™ is a product of AngeonX Inc. (angeonx.com | angeonx.ca)",
            poweredBy: "Powered by",
            version: "Version"
        }
    },
    defaultHome: {
        hero: {
            title: "Revolutionizing Sports Management",
            subtitle: "AI-powered scheduling, results tracking, and performance analytics. Sports management platform for leagues, tournaments and academies. Team and individual sports."
        },
        youtube: {
            title: "Watch Tutorials on YouTube",
            subtitle: "AngeonX Sports is transforming how leagues, tournaments, and academies manage sports — all from a single platform, designed for ultimate flexibility and control.",
            why: "Why AngeonX Sports?",
            because: "Because you need more than just spreadsheets and chats — you need powerful tools that work together.",
            visitButton: "Visit Channel"
        },
        keyFeatures: {
            title: "Key Features",
            feature1: {
                title: "Smart Scheduling",
                subtitle: "Automated scheduling minimizing conflicts."
            },
            feature2: {
                title: "Performance Insights",
                subtitle: "AI-driven player & team performance analytics."
            },
            feature3: {
                title: "Results & Stats",
                subtitle: "Track match results and standings easily."
            },
            feature4: {
                title: "Referee Rating",
                subtitle: "Rate referees/umpires based on performance."
            },
            feature5: {
                title: "Connect",
                subtitle: "Find organizations, teams, players, and referees."
            }
        },
        advertise: {
            title: "For Sponsors &amp; Local Businesses",
            subtitle: "Get your brand in front of players, parents, and teams in your area — directly inside the AngeonX Sports app.",
            bullet1: "Show your ad in our mobile app",
            bullet2: "Target by sport & location (soccer, baseball, etc.)",
            bullet3: "No long contract — run weekly campaigns"
        },
        elevate: {
            title: "Ready to Elevate Your Sports Organization?",
            subtitle: "Start managing your league with AI-driven scheduling and insights."
        },
        download: {
            title: "Get the AngeonX Sports App",
            subtitle: "Stay connected with your league, team, and events — right from your phone.",
            scanLabel: "Scan to download"
        }
    },
    termsPolicy: {
        heroTitle: "Terms of Service & Privacy Policy",
        effectiveDateLabel: "Effective Date",
        effectiveDate: "March 9, 2025",
        lastUpdatedLabel: "Last Updated",
        lastUpdated: "May 19, 2026",

        intro: {
            p1: "AngeonX Sports (\"we,\" \"us,\" \"our\") is operated by AngeonX Inc., a corporation incorporated in Manitoba, Canada.",
            p2: "By accessing or using the AngeonX Sports website or mobile applications (the \"Platform\"), you agree to be bound by these Terms of Service and Privacy Policy (\"Terms\"). If you do not agree, you must not use the Platform."
        },
        summary: {
            title: "Plain-Language Summary",
            p1: "To operate leagues and user benefits, we may share limited personal data with authorized partners only when needed to provide requested services.",
            bullets: [
                "This may include first name, last name, email, mobile number, and date of birth when required for league operations or insurance/benefit administration.",
                "We share only the minimum data required for the specific service purpose.",
                "By creating an account or continuing to use AngeonX Sports, you accept these data-use and data-sharing terms."
            ]
        },

        termsOfService: {
            title: "1. Terms of Service",

            eligibility: {
                title: "1.1 Eligibility",
                p1: "You must be at least 13 years old to use the Platform. If you are under the age of majority in your jurisdiction, you may only use the Platform under the supervision and consent of a parent or legal guardian. Parents or guardians are responsible for monitoring and supervising minors’ use of the Platform."
            },

            userAccounts: {
                title: "1.2 User Accounts",
                p1: "To use AngeonX Sports, you must provide accurate registration information including name, email, and mobile number. You agree to:",
                bullets: [
                    "Maintain the confidentiality of your login credentials.",
                    "Accept responsibility for all activity under your account.",
                    "Notify us immediately of any unauthorized access or use."
                ],
                p2: "We reserve the right to suspend or terminate accounts that violate these Terms."
            },

            platformPurpose: {
                title: "1.3 Platform Purpose",
                p1: "AngeonX Sports is a sports management platform that enables:",
                bullets: [
                    "League and academy management.",
                    "Team and player management.",
                    "Scheduling of games and events.",
                    "Live scoring and standings.",
                    "Messaging and communication.",
                    "Connect interactions.",
                    "Referee ratings and feedback.",
                    "Subscription-based premium features."
                ],
                p2: "The Platform is provided as a management tool only. We are not responsible for actual sports events, player performance, officiating decisions, or real-world outcomes."
            },

            userConduct: {
                title: "1.4 User Conduct",
                p1: "By using AngeonX Sports, you agree not to:",
                bullets: [
                    "Engage in harassment, hate speech, or abusive behavior.",
                    "Post defamatory, false, or misleading information.",
                    "Use the Platform for fraudulent or illegal activities.",
                    "Attempt to gain unauthorized access to any part of the Platform.",
                    "Reverse engineer, decompile, or otherwise attempt to derive the source code of the Platform."
                ],
                p2: "We reserve the right to remove content or suspend accounts at our discretion if we believe these Terms have been violated."
            },

            userGeneratedContent: {
                title: "1.5 User-Generated Content",
                p1: "Users may submit content including messages, ratings, statistics, announcements, photos, and profile information (collectively, \"User Content\").",
                p2: "You retain ownership of your User Content, but you grant AngeonX Sports (AngeonX Inc.) a non-exclusive, worldwide, royalty-free license to use, host, store, reproduce, modify, and display such content solely for the purpose of operating, maintaining, and improving the Platform.",
                p3: "You are solely responsible for the User Content you submit. We are not responsible for User Content posted by users but may remove content that violates these Terms or applicable law."
            },

            refereeRatings: {
                title: "1.6 Referee Ratings & Reviews",
                p1: "Users may submit ratings or feedback regarding referees, umpires, coaches, or other participants. By submitting such ratings, you agree to:",
                bullets: [
                    "Provide truthful and fair evaluations based on your experience.",
                    "Not post defamatory, discriminatory, or malicious content."
                ],
                p2: "Opinions expressed in ratings and feedback are those of the individual users and do not necessarily represent the views of AngeonX Sports. We are not responsible for the content of such ratings but may remove or moderate them where appropriate."
            },

            subscriptions: {
                title: "1.7 Subscriptions, Billing & Refund Policy",
                p1: "Certain Platform features are available only through paid subscriptions or premium plans. By subscribing, you agree to:",
                bullets1: [
                    "Pay all applicable fees associated with your chosen plan.",
                    "Automatic renewal of your subscription at the end of each billing period, unless you cancel before renewal.",
                    "Prices may vary by currency and region, and taxes may apply."
                ],
                p2: "You may cancel your subscription at any time through the Platform, and you will retain access to premium features until the end of the current billing period. Unless required by law, subscription fees are non-refundable.",
                p3: "If a free trial is offered, users will have access to premium features for the duration of the trial period at no cost.",
                p4: "At the end of the trial period:",
                bullets2: [
                    "The subscription will not automatically convert into a paid plan.",
                    "The user’s account will be automatically downgraded to the Free plan unless the user actively subscribes to a paid plan.",
                    "No charges will be applied unless the user explicitly completes a paid subscription purchase."
                ],
                p5: "Details of trial duration and included features will be provided at the time of enrollment."
            },

            stripe: {
                title: "1.8 Stripe Payment Processing",
                p1: "All payment transactions on AngeonX Sports are processed by Stripe, Inc. (\"Stripe\"). We do not collect, store, or process your full credit card or payment details directly. When you make a purchase or subscribe to a plan, your payment details are transmitted directly to Stripe and are subject to Stripe’s policies.",
                p2: "By making any payment through the Platform, you:",
                bullets: [
                    "Agree to be bound by Stripe’s Terms of Service and Privacy Policy.",
                    "Acknowledge that payment processing services are provided by Stripe and are subject to Stripe’s agreements."
                ],
                p3: "Stripe’s current policies are available at",
                legalLinkLabel: "Stripe Legal",
                privacyLinkLabel: "Stripe Privacy",
                p4: "We are not responsible for:",
                bullets2: [
                    "Payment processing delays or failures.",
                    "Card authorization or fraud checks performed by Stripe or your bank.",
                    "Chargeback handling or dispute resolutions governed by Stripe’s rules.",
                    "Currency conversion rates applied by Stripe or your financial institution."
                ]
            },

            thirdParty: {
                title: "1.9 Third-Party Services",
                p1: "We may use third-party service providers to operate and support the Platform, including but not limited to:",
                bullets: [
                    "Payment processors (e.g., Stripe).",
                    "Cloud hosting providers.",
                    "Notification and messaging services.",
                    "Analytics providers.",
                    "Authorized sports partners (such as leagues and federations) and benefit providers (such as insurance companies) when needed to deliver requested services or benefits."
                ],
                p2: "Use of these third-party services may be subject to their respective terms and privacy policies."
            },

            intellectualProperty: {
                title: "1.10 Intellectual Property",
                p1: "All content and materials on the Platform, including but not limited to the AngeonX Sports name, logo, branding, software code, user interface design, and trademarks, are owned by AngeonX Inc. or its licensors and are protected by intellectual property laws.",
                p2: "You may not reproduce, distribute, modify, create derivative works of, or publicly display any part of the Platform without our prior written permission.",
                p3: "White-label or Elite subscriptions may allow cosmetic branding customization (e.g., custom logo, colors, or subdomain) for organizations but do not transfer ownership of the underlying software or Platform."
            },

            marketingRights: {
                title: "1.11 Marketing & Publicity Rights",
                p1: "By using the Platform, organizations and users grant AngeonX Sports (AngeonX Inc.) a non-exclusive, worldwide, royalty-free license to use the following information for marketing and promotional purposes:",
                bullets1: [
                    "Organization, league, and team names.",
                    "Publicly displayed logos and branding assets.",
                    "Testimonials voluntarily submitted by users or organizations.",
                    "Non-sensitive usage statistics (e.g., number of games, leagues, or teams managed).",
                    "Public screenshots of standings, schedules, or Platform views without exposing personal data."
                ],
                p2: "This license is solely for:",
                bullets2: [
                    "Marketing campaigns and promotional materials.",
                    "Website showcases and case studies.",
                    "Social media posts.",
                    "Sales or investor presentations."
                ],
                p3: "We will not use:",
                bullets3: [
                    "Private personal data such as email addresses or phone numbers for public marketing.",
                    "Financial information or payment details.",
                    "Sensitive personal data.",
                    "Identifiable images or personal information of minors for marketing without appropriate consent (e.g., parental or organizational consent where required)."
                ],
                p4: "If an organization or user wishes to opt out of marketing use, they may contact us in writing at",
                email: "kbolasports@angeonx.com"
            },

            advertising: {
                title: "1.12 Advertising & Sponsorship",
                p1: "The Platform may display advertisements, sponsor banners, or promotional content. We do not endorse or guarantee any third-party products or services featured in such advertisements.",
                p2: "Users interact with advertisers or sponsors at their own risk, and any disputes or claims are solely between the user and the third party."
            },

            serviceAvailability: {
                title: "1.13 Service Availability & Disclaimer of Warranties",
                p1: "The Platform is provided on an \"as is\" and \"as available\" basis without warranties of any kind, whether express or implied, including but not limited to implied warranties of merchantability, fitness for a particular purpose, or non-infringement.",
                p2: "We do not warrant that:",
                bullets: [
                    "The Platform will be uninterrupted, timely, secure, or error-free.",
                    "Data (including scores, standings, or schedules) will always be accurate or up to date.",
                    "Defects will be corrected immediately."
                ]
            },

            limitation: {
                title: "1.14 Limitation of Liability",
                p1: "To the maximum extent permitted by law, AngeonX Sports and AngeonX Inc. (including its directors, officers, employees, and affiliates) shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or for any loss of profits or revenues, whether incurred directly or indirectly, or any loss of data, goodwill, or other intangible losses, resulting from:",
                bullets: [
                    "Your access to or use of, or inability to access or use, the Platform.",
                    "Any conduct or content of other users or third parties on the Platform.",
                    "Errors or inaccuracies in schedules, results, standings, or statistics.",
                    "Downtime, delays, or failures of infrastructure or third-party services.",
                    "Payment processing issues, disputes, or chargebacks handled by Stripe or banks."
                ]
            },

            indemnification: {
                title: "1.15 Indemnification",
                p1: "You agree to indemnify and hold harmless AngeonX Inc., AngeonX Sports, and their officers, directors, employees, and agents from and against any claims, liabilities, damages, losses, and expenses (including reasonable legal fees) arising out of or in any way connected with:",
                bullets: [
                    "Your access to or use of the Platform.",
                    "Your violation of these Terms.",
                    "Your User Content.",
                    "Any dispute between you and another user or organization."
                ]
            },

            governingLaw: {
                title: "1.16 Governing Law",
                p1: "These Terms are governed by and construed in accordance with the laws of the Province of Manitoba and the federal laws of Canada applicable therein. Any disputes arising from these Terms or your use of the Platform shall be subject to the exclusive jurisdiction of the courts located in Manitoba, Canada."
            }
        },

        privacyPolicy: {
            title: "2. Privacy Policy",

            collect: {
                title: "2.1 Information We Collect",
                p1: "When you use AngeonX Sports, we collect the following types of information:",
                bullets: [
                    "Personal Information: First name, last name, email address, mobile number, date of birth, and other profile details provided by you.",
                    "Usage Information: Activity logs, device information, IP address, interactions with Platform features, and performance analytics used to improve our services.",
                    "Subscription Information: Plan type, billing status, currency, and related non-card payment data."
                ]
            },

            payments: {
                title: "Payments and Credit Card Information",
                p1: "We do not collect, store, or process your credit card or payment information directly. All payment transactions are securely handled by our trusted third-party payment processor, Stripe. When you make a purchase or subscribe to a plan, your payment details are transmitted directly to Stripe and are subject to their Privacy Policy and Terms of Service. By using our services and making any payment through our Platform, you also agree to be bound by Stripe’s policies and terms."
            },

            useData: {
                title: "2.2 How We Use Your Data",
                p1: "We use the information we collect to:",
                bullets: [
                    "Create and manage your account.",
                    "Enable communication and collaboration between users via chat and notifications.",
                    "Operate and manage leagues, teams, schedules, and events.",
                    "Provide customer support and respond to inquiries.",
                    "Improve and optimize Platform features and performance.",
                    "Enforce these Terms and protect the integrity of the Platform."
                ]
            },

            contactSharing: {
                title: "2.3 Contact Information Sharing",
                p1: "By default, your contact information (name, email, mobile number) is not shared with third parties outside the Platform. Within the Platform:",
                bullets: [
                    "You may choose in your preferences to share your contact data (email and mobile) with organization managers or team managers within the app Connect module to coordinate opportunities or invitations.",
                    "If you do not enable this sharing, all communication is handled through the in-app messaging and chat system."
                ]
            },

            dataSharing: {
                title: "2.4 Data Sharing Policy",
                p1: "We do not sell your personal information. We share personal information only when necessary to operate the Platform, provide requested sports services or benefits, or comply with legal obligations. We may share data with:",
                bullets: [
                    "With service providers (e.g., Stripe, hosting, notifications) who assist in operating the Platform.",
                    "With authorized partner organizations involved in sports operations or user benefits (for example, leagues, federations, or insurance companies), only for legitimate service purposes such as eligibility checks, registration, scheduling, claims administration, or benefit activation.",
                    "Only the minimum data required for the specific purpose, which may include first name, last name, email, mobile number, and date of birth when required by the partner service.",
                    "When required by law, regulation, or legal process.",
                    "To protect the rights, property, or safety of AngeonX Sports, our users, or the public."
                ],
                p2: "AngeonX Sports and AngeonX Inc. are not responsible for the independent misuse of personal data by third-party organizations after lawful sharing under this Policy. However, we require authorized third parties to process data only for approved service purposes and under appropriate contractual and legal safeguards."
            },

            retention: {
                title: "2.5 Data Retention",
                p1: "We retain personal data for as long as your account remains active or as necessary to provide the Platform and comply with legal obligations. After account deletion:",
                bullets: [
                    "We remove or anonymize personal profile data where feasible.",
                    "Some data (e.g., logs, backups) may be retained for a limited period for security, fraud prevention, or legal compliance."
                ]
            },

            security: {
                title: "2.6 Data Security",
                p1: "We implement industry-standard technical and organizational measures to protect your information from unauthorized access, loss, misuse, or alteration. However, no online platform can guarantee 100% security, and you are responsible for safeguarding your login credentials."
            },

            children: {
                title: "2.7 Children's Privacy",
                p1: "We do not knowingly collect personal information from children under 13 without parental consent. If we become aware that we have collected personal information from a child under 13 without appropriate consent, we will take steps to delete such information.",
                p2: "Parents or guardians who believe their child has provided personal information may contact us at",
                email: "kbolasports@angeonx.com",
                p3: "to request deletion."
            },

            international: {
                title: "2.8 International Users",
                p1: "If you access the Platform from outside Canada, you understand and agree that your information may be transferred to, stored in, and processed in Canada and other countries where our service providers operate. Data protection laws may differ from those in your jurisdiction."
            },

            rights: {
                title: "2.9 Your Rights",
                p1: "Depending on your jurisdiction, you may have rights regarding your personal data, including the right to:",
                bullets: [
                    "Request access to the personal data we hold about you.",
                    "Request correction of inaccurate or incomplete data.",
                    "Request deletion of your personal data, subject to legal requirements.",
                    "Control how your contact information is shared within the Platform."
                ],
                p2: "Requests related to your data can be submitted to",
                email: "kbolasports@angeonx.com"
            },

            updates: {
                title: "2.10 Policy Updates",
                p1: "We may update these Terms and this Privacy Policy from time to time to reflect changes in our practices, legal requirements, or Platform features. When we make material changes, we will notify you through the Platform or by other reasonable means. Your continued use of the Platform after such changes constitutes your acceptance of the updated Terms."
            }
        },

        contact: {
            title: "3. Contact Us",
            p1: "If you have any questions about these Terms of Service or this Privacy Policy, or if you wish to exercise any of your rights, please contact us at:",
            company: "AngeonX Inc.",
            city: "Winnipeg, Manitoba, Canada",
            emailLabel: "Email",
            email: "kbolasports@angeonx.com",
            p2: "By creating an account, accessing, or continuing to use AngeonX Sports, you acknowledge that you have read, understood, and agree to these Terms of Service and this Privacy Policy, including the limited sharing of personal data with authorized leagues and benefit providers (such as insurance companies) strictly to provide requested services and benefits."
        }
    },
    header: {
        quickActions: {
            title: "Quick actions",
            subtitle: "Create and navigate faster",
            newOrg: "New Organization",
            addVenue: "Add Venue",
            subscriptions: "Subscriptions",
            newSponsor: "New Sponsor",
            newCampaign: "New Campaign"
        },
        notifications: {
            title: "Notifications",
            unread: "unread",
            subtitle: "You're all caught up",
            noUnread: "No unread notifications",
            info: "You’ll see updates here as activity happens.",
            viewMore: "View more"
        },
        switchProfile: {
            title: "Switch profile",
            profile: "profile",
            active: "Currently active",
            switchProfile: "Switch to this profile",
            activeBadge: "Active",
            switch: "Switch",
            plans: "Plans",
            invoices: "Invoices",
            subscriptions: "Subscriptions",
            logout: "Logout"
        }
    },
    sidebar: {
        core: "Core",
        people: "People",
        management: "Management",
        officials: "Officials",
        referees: "Referees / Umpires",
        assignments: "Assignments",
        organizations: "Organizations",
        players: "Players",
        financialDashboard: "Financial Dashboard",
        settings: "Settings",
        venue: "Facilities",
        waivers: "Waivers",
        sanctions: "Sanction & Rules",
        payoutAccounts: "Payout Accounts",
        staff: "Staff",
        subscriptions: "Subscriptions",
        plans: "Plans",
        invoices: "Invoices",
        admin: "Admin",
        advertising: "Advertising",
        adsDashboard: "Ads Dashboard",
        dashboard: "Dashboard",
        audience: "Audience",
        managementData: "Management data",
        sponsors: "Sponsors",
        campaigns: "Campaigns",
        commerce: "Commerce",
        marketplace: "Marketplace"
    },
    refereesPage: {
        title: "Referees / Umpires", officialsTitle: "Officials", officialsEmpty: "No active officials found.", addOfficial: "Add official", addExistingOfficial: "Add existing official", createOfficial: "Create new official", officialRole: "Official", findOfficials: "Find officials", filterOfficials: "Search and filter your organization officials.",
        settings: "Settings",
        subtitle: "Manage the active officials in your organization.",
        empty: "No active referees or umpires found.",
        add: "Add referee", addExisting: "Add existing referee", create: "Create new referee",
        official: "Official",
        organization: "Organization",
        contact: "Contact",
        location: "Location",
        status: "Status", activate: "Activate", deactivate: "Deactivate", statuses: {accepted: "Active", inactive: "Inactive"},
        roleLabel: "Referee / Umpire",
        detailsEyebrow: "Official profile", viewDetails: "View details", rating: "Rating",
        filtersBadge: "Filters", filtersTitle: "Find referees", filtersSubtitle: "Search and filter your organization officials.", search: "Search", searchPlaceholder: "Search by name or email", allOrganizations: "All organizations", sport: "Sport", allSports: "All sports", allStatuses: "All statuses",
    },
assignmentsPage: {
        upgradePlanLabel: "PREMIUM", upgradeTitle: "Game Assignments Unavailable", upgradeSubtitle: "This feature is available on Enterprise Organization plans.", upgradeCta: "Upgrade", upgradeTextPrefix: "To manage game assignments for your organizations, please", upgradeTextLink: "upgrade your subscription",
        cancelOfficial: "Cancel invitation", assignmentCancelled: "Official assignment cancelled.",
        manageOfficials: "Manage officials",
        matchDay: "Matchday",
        detailsBadge: "Assignment details", historyTitle: "Invitation history", historySubtitle: "Review every official invitation and response for this game.", unknownOfficial: "Unknown official", assignedBy: "Assigned by", systemAssignment: "System assignment", noAssignmentHistory: "No invitation history", noAssignmentHistoryHint: "No official invitations have been created for this game.",
        facilityTerm: "Facilities", assignFacilities: "Assign facilities", facility: "Facility", selectFacility: "Select a facility", facilityHint: "The selected facility will be applied to every selected game.", facilitiesTableTitle: "Facility assignments", facilitiesTableSubtitle: "Review and assign facilities across divisions from one workspace.",
        summary: {scheduled: "Scheduled", accepted: "Covered", pending: "Pending", unassigned: "Unassigned"},
        filters: "Filters", scheduledOnly: "Scheduled games only", clearFilters: "Clear filters",
        allOfficials: "All officials",
        assignmentModeAll: "All games", assignmentModePerGame: "By game", coordinatorAssignmentModeHint: "The selected coordinators will be applied to every selected game.",
        applyToAllGames: "Apply to all games", saveAssignment: "Save assignments",
        fieldConflict: "Field is already booked during this time.", refereeConflict: "Referee is already assigned during this time.", coordinatorConflict: "Coordinator is already assigned during this time.", conflictingEvent: "Conflicting event:", conflictingSelection: "Conflicting selection:",
        assigned: "Assigned", unassigned: "Unassigned", officialsTerm: "Officials", officialsWorkspaceTitle: "Official assignments", officialsWorkspaceBadge: "Officials", officialsWorkspaceSubtitle: "Coordinate official coverage across all divisions in your organization.", officialsTableTitle: "Official assignments", officialsTableSubtitle: "Select scheduled games to invite officials from their stage pools.", officialsColumn: "Officials", officialsToInvite: "Officials to invite", noOfficialsAssigned: "No officials assigned", assignOfficials: "Assign officials",
        badge: "Official operations", title: "Referee assignments", subtitle: "Coordinate referee coverage across all divisions in your organization.", tableSubtitle: "Select scheduled games to invite referees from their stage pools.", organization: "Organization", selectOrganization: "Select organization", division: "Division", allDivisions: "All divisions", season: "Season", allSeasons: "All seasons", status: "Assignment status", allStatuses: "All statuses", dateFrom: "Date from", dateTo: "Date to", allFields: "All fields", allCoordinators: "All coordinators", games: "games", game: "Game", divisionStage: "Division / stage", dateLocation: "Date / location", referees: "Referees / umpires", noReferee: "No referee assigned", selectAll: "Select all scheduled games on this page", assignSelected: "Assign referees", assignCoordinator: "Assign coordinator", assignField: "Assign field", coordinators: "Coordinators", field: "Field", selectField: "Select a field", fieldHint: "The selected field will be applied to every selected game.", coordinatorHint: "Select one or more coordinators for every selected game.", selectedGames: "{{count}} selected game(s)", noCoordinators: "No coordinators available.", selectGameFirst: "Select at least one scheduled game.", updated: "Assignments updated successfully.", updateFailed: "Could not update assignments.", tabs: {officials: "Officials", coordinators: "Coordinators", fields: "Fields"}, tables: {officials: {title: "Referee assignments", subtitle: "Select scheduled games to invite referees from their stage pools.", assignees: "Referees / umpires", empty: "No referee assigned"}, coordinators: {title: "Coordinator assignments", subtitle: "Assign coordinators across divisions from one workspace.", assignees: "Coordinators", empty: "No coordinator assigned"}, fields: {title: "Field assignments", subtitle: "Review and assign fields across divisions from one workspace.", assignees: "Field", empty: "No field assigned"}}, noOrganizationTitle: "No organization available", noOrganizationSubtitle: "You need access to an organization before managing referee assignments.",
    },
    managementData: {
        title: "Management data",
        subtitle: "Staff dashboard for platform adoption, client activation, and operational usage.",
        admin: "Admin",
        staffOnly: "This dashboard is only available to staff users.",
        loading: "Loading management data...",
        loadError: "Could not load management data.",
        healthLoadError: "Could not load organization health data.",
        noData: "No data available",
        periodFilter: "Reporting period",
        periods: {
            lastWeek: "Last week",
            last30Days: "Last 30 days",
            last3Months: "Last 3 months",
            last6Months: "Last 6 months",
            last1Year: "Last 1 year"
        },
        cards: {
            clients: "Client organizations",
            activeClients: "{count} active clients",
            activeUsers: "Active users",
            totalUsers: "{count} total users",
            periodRegistrations: "Period registrations",
            selectedPeriod: "Teams plus players in selected period",
            completedGames: "Completed games",
            totalGames: "{count} total games"
        },
        periodCards: {
            organizations: "New organizations",
            orgBreakdown: "{leagues} leagues · {academies} academies · {teams} teams",
            structure: "New divisions/seasons",
            structureHint: "{stages} stages · {groups} groups",
            gamesCreated: "Games created",
            results: "{count} results completed",
            newUsers: "New users",
            activeUsers: "{count} active in period"
        },
        charts: {
            growthTitle: "Adoption trend",
            growthSubtitle: "New organizations, users, and games by rolling period.",
            activationTitle: "Client activation funnel",
            activationSubtitle: "How many client organizations reached each setup milestone.",
            organizationSubscriptionsTitle: "Organization subscriptions",
            organizationSubscriptionsSubtitle: "Active web subscriptions by plan.",
            userSubscriptionsTitle: "User subscriptions",
            userSubscriptionsSubtitle: "Active app subscriptions and recent active users by plan.",
            organizationTypesTitle: "Organization type breakdown",
            organizationTypesSubtitle: "Current inventory and recent growth by type."
        },
        chartLabels: {
            organizations: "Organizations",
            users: "Users",
            games: "Games",
            clients: "Client organizations",
            active30Days: "Active 30 days"
        },
        funnel: {
            clients: "Clients",
            divisions: "Divisions",
            seasons: "Seasons",
            teams: "Teams",
            players: "Players",
            results: "Results"
        },
        tables: {
            topOrganizations: "Top activated clients",
            atRiskOrganizations: "Clients needing attention",
            atRiskOrganizationsLoading: "Clients needing attention · loading...",
            organizationSubscriptions: "Organization plan counts",
            organizationSubscriptionsSubtitle: "How many organizations are currently on each web plan.",
            userSubscriptions: "User plan counts",
            userSubscriptionsSubtitle: "How many users are currently on each app plan, with recent activity."
        },
        table: {
            organization: "Organization",
            organizations: "Organizations",
            score: "Score",
            plan: "Plan",
            divisions: "Divisions",
            teams: "Teams",
            players: "Players",
            users: "Users",
            active7Days: "Active 7d",
            active30Days: "Active 30d",
            active90Days: "Active 90d",
            completed: "Completed",
            type: "Type",
            total: "Total",
            active: "Active",
            createdLast30Days: "Created last 30 days"
        }
    },
    financial: {
        noticeTitle: "Heads up:",
        noticeText1: "Payments processed through AngeonX Sports use Stripe Connect.",
        noticeText2: "Stripe typically charges",
        noticeText3: "per transaction, and AngeonX Sports applies a",
        noticeText4: "platform fee (ELITE subscriptions with 2.5% platform fee). These are deducted before payout to the organization.",
        example: "Example with a {amount} payment → The organization would net approximately {net}.",
        filtersBadge: "Filters",
        paymentsTitle: "Payments",
        filtersSubtitle: "Choose organization, division, season, and status.",
        resetFilters: "Reset filters",
        reset: "Reset",

        organization: "Organization",
        selectLeague: "Select League",
        division: "Division",
        selectDivision: "Select Division",
        season: "Season",
        selectSeason: "Select Season",
        status: "Status",
        all: "All",
        pending: "Pending",
        paid: "Paid",

        autoRefreshHint: "Changes automatically refresh the table.",

        total: "Total",
        overall: "Overall",
        outstanding: "Outstanding",

        tableTitle: "Payments",
        tableHeaders: {
            status: "Status",
            amount: "Amount",
            description: "Description",
            organization: "Organization",
            season: "Season",
            game: "Game",
            relatedObject: "Related Object",
            profile: "Profile",
            createdAt: "Created At",
            dueDate: "Due Date",
            sanction: "Sanction"
        },

        noValue: "—"
    },
    feeCalculator: {
        badge: "Calc",
        subtitle: "Estimate platform and Stripe Connect fees.",
        currencyInUse: "Currency in use",

        currency: "Currency",
        amountPaid: "Amount Paid",
        appFeePct: "App Fee %",
        stripePct: "Stripe %",
        stripeFixed: "Stripe Fixed",

        breakdownTitle: "Breakdown",
        breakdownSubtitle: "These values are estimates and can vary by country/payment method.",

        userPays: "User pays",
        kbolaFee: "AngeonX Sports fee ({pct}%)",
        amountBeforeStripe: "Amount before Stripe fee",
        stripeFee: "Stripe fee ({pct}% + {fixed})",
        organizationReceives: "Organization receives",

        stripeAccountNote: "Stripe fees are charged to the connected account.",

        defaultTitle: "Fee Calculator"
    },
    venuesPage: {
        pageTitle: "Facilities",
        settings: "Settings",

        tableTitle: "Facilities",
        headers: {
            name: "Name",
            description: "Description",
            fields: "Fields",
            createdBy: "Created By",
            actions: "Actions"
        },

        noValue: "—",
        fieldTitle: "Field",

        editVenue: "Edit venue",
        deleteVenue: "Delete venue",

        deleteConfirmTitle: "Delete venue?",
        deleteConfirmMessage: "You're about to delete \"{name}\".\n\nThe venue and its fields will be removed. This may affect scheduled games using these fields.\n\nAre you sure you want to continue?",
        deleteConfirmButton: "Delete Venue",
        cancel: "Cancel",

        deleteSuccess: "Venue deleted successfully!",
        deleteFailed: "Failed to delete venue.",
        loadFailed: "Failed to load venues."
    },
    staffPage: {
        pageTitle: "Staff",
        settings: "Settings",
        subtitle: "Managers and coordinators in your leagues",
        searchPlaceholder: "Search managers or coordinators...",
        noOrganizations: "No leagues linked",
        noOrganizationName: "Unknown league",
        upgradePlanLabel: "PREMIUM",
        upgradeTitle: "Staff Management Unavailable",
        upgradeSubtitle: "This feature is available on Enterprise Organization plans.",
        upgradeCta: "Upgrade",
        upgradeTextPrefix: "To manage managers and coordinators for your organizations, please",
        upgradeTextLink: "upgrade your subscription",
        roles: {
            manager: "Manager",
            coordinator: "Coordinator"
        }
    },
    playersPage: {
        pageTitle: "Players",
        settings: "Settings",
        subtitle: "Players and coaches in your leagues",
        filtersBadge: "Filters",
        filtersTitle: "Players",
        filtersSubtitle: "Filter by organization and profile role.",
        search: "Search",
        searchPlaceholder: "Search by name, email, phone, team, or organization...",
        organization: "Organization",
        allOrganizations: "All organizations",
        profile: "Profile",
        allProfiles: "All profiles",
        resetFilters: "Reset filters",
        reset: "Reset",
        download: "Download",
        downloading: "Downloading...",
        downloadExcel: "Download filtered list as Excel",
        upgradePlanLabel: "PREMIUM",
        upgradeTitle: "Players List Unavailable",
        upgradeSubtitle: "This feature is available on Enterprise Organization plans.",
        upgradeCta: "Upgrade",
        upgradeTextPrefix: "To view and export players and coaches for your organizations, please",
        upgradeTextLink: "upgrade your subscription",
        autoRefreshHint: "Changes automatically refresh the list.",
        noValue: "—",
        roles: {
            coach: "Coach",
            player: "Player"
        },
        gender: {
            male: "Male",
            female: "Female"
        },
        fields: {
            fullName: "Full name",
            email: "Email",
            phone: "Phone",
            gender: "Gender",
            dob: "Date of birth",
            organization: "Organization",
            activeTeam: "Active team",
            role: "Role",
            league: "League"
        }
    },
    staffPicker: {
        title: "Add manager to organization",
        organization: "Organization",
        noOrganizations: "No organizations available",
        profile: "User profile",
        searchPlaceholder: "Search user profiles...",
        add: "Add",
        alreadyAdded: "Added",
        loadError: "Failed to load user profiles.",
        noProfiles: "No user profiles available.",
        noSearchResults: "No user profiles found for this search.",
        addSuccess: "Manager added successfully.",
        addError: "Could not add this manager."
    },
    refereePicker: {
        title: "Add referee / umpire to organization",
        organization: "Organization", noOrganizations: "No organizations available", profile: "User profile",
        searchPlaceholder: "Search referees and umpires...", add: "Add", alreadyAdded: "Added",
        loadError: "Failed to load referees.", noProfiles: "No referees available.", noSearchResults: "No referees found for this search.",
        addSuccess: "Referee added successfully.", addError: "Could not add this referee."
    },
    table: {
        subtitle: "Manage the items in this list",
        add: "Add",
        loading: "Loading…",
        noRecords: "No records found",
        prev: "Previous",
        next: "Next",
        page: "Page",
        of: "of",
        previousPage: "Previous page",
        nextPage: "Next page",
        pagination: "Pagination",
        total: "Total",
        toggleDropdown: "Show options",
        addItemTitle: "Add {title}",
        goToPage: "Go to page {page}"
    },
    venueCreateModal: {
        "venueNameRequired": "Venue name is required.",
        "addressRequired": "Please select a valid address.",
        "fieldLabel": "Field {{number}}",
        "removeField": "Remove",
        badge: "NEW",
        title: "Create Venue",
        subtitle: "Add a facility and its fields.",

        close: "Close",

        venueName: "Venue name",
        venueNamePlaceholder: "e.g., Maple Sports Complex",

        description: "Description (optional)",
        descriptionPlaceholder: "Any notes about this facility…",

        address: "Address",
        addressPlaceholder: "Search for sport facilities",

        fieldsTitle: "Fields",
        itemsCount: "{count} item(s)",

        fieldName: "Field name",
        fieldNamePlaceholder: "e.g., Field A",

        fieldDescription: "Description",
        fieldDescriptionPlaceholder: "e.g., Turf, lights, size…",

        addAnotherField: "Add Another Field",
        addAnotherFieldTitle: "Add another field",

        cancel: "Cancel",
        creating: "Creating…",
        createVenue: "Create Venue",

        validationAtLeastOneField: "Please enter at least one Field.",
        createSuccess: "Venue created successfully!",
        createFailed: "Failed to create venue."
    },
    venueEditModal: {
        "addressRequired": "Please select a valid address.",
        "fieldLabel": "Field {{number}}",
        "existingField": "Existing",
        "newField": "New",
        "removeField": "Remove",
        badge: "EDIT",
        title: "Edit Venue",
        subtitle: "Update facility details and fields.",

        close: "Close",

        venueName: "Venue name",
        venueNameRequired: "Venue name is required.",

        description: "Description (optional)",

        address: "Address",
        addressPlaceholder: "Search for sport facilities",

        fieldsTitle: "Fields",
        itemsCount: "{count} item(s)",

        fieldName: "Field name",
        fieldNamePlaceholder: "e.g., Field A",

        fieldDescription: "Description",
        fieldDescriptionPlaceholder: "e.g., Turf, lights, size…",

        addAnotherField: "Add Another Field",

        cancel: "Cancel",
        saving: "Saving…",
        updateVenue: "Update Venue",

        updateSuccess: "Venue updated successfully!",
        updateFailed: "Failed to update venue."
    },
    waiversPage: {
        pageTitle: "Waivers",
        settings: "Settings",

        upgradePlanLabel: "PREMIUM",
        upgradeTitle: "Waiver Management Unavailable",
        upgradeSubtitle: "This feature is available on Pro/Elite Organization plans.",
        upgradeCta: "Upgrade",
        upgradeTextPrefix: "To create and manage waivers for your organizations, please",
        upgradeTextLink: "upgrade your subscription",

        tableTitle: "Waivers",
        tableHeaders: {
            title: "Title",
            type: "Type",
            language: "Language",
            createdBy: "Created By",
            actions: ""
        },

        noValue: "—",
        waiverTypeLabel: "Waiver type",
        document: "Document",
        text: "Text",
        view: "View",

        editWaiver: "Edit waiver",
        deleteWaiver: "Delete waiver",

        createBadge: "NEW",
        createTitle: "Create Waiver",
        createSubtitle: "Add a waiver (Text or Document) to your organization.",

        deleteConfirmTitle: "Delete Waiver",
        deleteConfirmMessage: "The waiver \"{title}\" will be permanently deleted. Players will no longer be able to sign it, and any pending signature requests will be invalid.\n\nAre you sure you want to continue?",
        deleteConfirmButton: "Yes, delete",
        deleteCancelButton: "No",

        createSuccess: "Waiver created successfully!",
        updateSuccess: "Waiver updated successfully!",
        deleteSuccess: "Waiver deleted successfully!",
        updateFailed: "Failed to update waiver.",
        deleteFailed: "Failed to delete waiver.",
        loadFailed: "Failed to load waivers."
    },

    createWaiverForm: {
        title: "Title",
        titlePlaceholder: "e.g. Tournament Participation Waiver",

        language: "Language",
        waiverType: "Waiver Type",
        text: "Text",
        documentPdf: "Document (PDF)",

        content: "Content",
        contentPlaceholder: "Write the waiver text here…",
        contentHelper: "Tip: keep it clear and concise; include risk acknowledgement and consent.",

        pdfDocument: "PDF Document",
        noFileSelected: "No file selected",
        pdfHelper: "Upload a PDF waiver that participants can view and sign.",
        choosePdf: "Choose PDF",

        close: "Close",
        uploading: "Uploading…",
        createWaiver: "Create Waiver"
    },

    textWaiverModal: {
        title: "Waiver Content",
        close: "Close"
    },

    waiverEditModal: {
        badge: "EDIT",
        title: "Edit Waiver",
        subtitle: "Update title, type, and content.",

        close: "Close",
        titleLabel: "Title",
        titlePlaceholder: "Waiver title",
        titleHelper: "This is the name admins will see in lists.",

        waiverType: "Waiver Type",
        text: "Text",
        document: "Document",
        waiverTypeHelper: "Switch between text and document. Upload a PDF when using Document type.",
        language: "Language",

        createdBy: "Created By",
        readOnly: "Read-only.",

        content: "Content",
        contentPlaceholder: "Write your waiver text...",
        contentHelper: "Keep it clear and legally consistent. Consider adding a signature acknowledgment section.",
        pdfDocument: "PDF Document",
        noFileSelected: "No file selected",
        pdfHelper: "Upload a new PDF to replace the current document (optional).",
        viewCurrentDocument: "View current document",
        choosePdf: "Choose PDF",

        cancel: "Cancel",
        saving: "Saving...",
        saveChanges: "Save Changes"
    },
    sanctionRulesPage: {
        pageTitle: "Sanctions Management",
        settings: "Settings",
        rulesPageTitle: "Sanction Rules",

        upgradePlanLabel: "PREMIUM",
        upgradeTitle: "Sanction Rules Management Unavailable",
        upgradeSubtitle: "This feature is available on Pro/Elite Organization plans.",
        upgradeCta: "Upgrade",
        upgradeTextPrefix: "To create and manage sanctions and rules for your organizations, please",
        upgradeTextLink: "upgrade your subscription",

        tableTitle: "Sanction Rules",
        tableSubtitle: "Create and manage disciplinary rules for your organization.",
        tableHeaders: {
            name: "Name",
            createdBy: "Created By",
            actions: ""
        },

        noValue: "—",
        editRule: "Edit rule",
        deleteRule: "Delete rule",

        createBadge: "NEW",
        createTitle: "Create Sanction Rule",
        createSubtitle: "Define a disciplinary rule for your organization.",

        deleteConfirmTitle: "Delete Sanction Rule",
        deleteConfirmMessage: "The rule \"{name}\" will be permanently removed.\n\nAny future disciplinary actions will no longer be able to reference this rule.\n\nAre you sure you want to continue?",
        deleteConfirmButton: "Yes, delete",
        deleteCancelButton: "No",

        createSuccess: "Sanction Rule created successfully!",
        updateSuccess: "Sanction Rule updated successfully!",
        deleteSuccess: "Sanction Rule deleted successfully!",
        updateFailed: "Failed to update sanction rule.",
        deleteFailed: "Failed to delete sanction rule.",
        loadFailed: "Failed to load sanction rules."
    },
    createSanctionRuleForm: {
        sections: {
            basics: {
                title: "Basics",
                hint: "Rule identity and accumulation limit."
            },
            suspensions: {
                title: "Suspensions",
                hint: "Games applied per card scenario."
            },
            resets: {
                title: "Resets & Overrides",
                hint: "Control how accumulation resets."
            },
            fines: {
                title: "Fines",
                hint: "Optional monetary penalties (leave blank for none)."
            }
        },

        fields: {
            ruleName: "Rule Name",
            ruleNamePlaceholder: "e.g., Standard Yellow/Red Accumulation",

            maxAccumulatedYellowCards: "Max Accumulated Yellow Cards",
            accumulatedYellowSuspensionGames: "Accumulated Yellow Suspension (games)",

            redCardSuspension: "Red Card Suspension",
            doubleYellowSuspension: "Double Yellow Suspension",
            accumulatedYellowSuspension: "Accumulated Yellow Suspension",

            yellowCardFine: "Yellow Card Fine ($)",
            yellowCardFinePlaceholder: "e.g., 10.00",
            doubleYellowFine: "Double Yellow Fine ($)",
            doubleYellowFinePlaceholder: "e.g., 25.00",
            redCardFine: "Red Card Fine ($)",
            redCardFinePlaceholder: "e.g., 50.00"
        },

        toggles: {
            resetOnRed: {
                title: "Reset yellow cards after red card",
                hint: "Useful when red is treated as a full reset event."
            },
            resetOnDoubleYellow: {
                title: "Reset yellow cards after double yellow",
                hint: "Clears accumulation when a player is sent off via 2 yellows."
            },
            overrideAccumulation: {
                title: "Double yellow overrides accumulation sanction",
                hint: "Prevents stacking double-yellow + accumulation penalty."
            },
            resetOnStageChange: {
                title: "Reset yellow cards on stage change",
                hint: "Example: group stage → playoffs."
            },
            resetSanctionsOnStageChange: {
                title: "Reset sanctions on stage change",
                hint: "Clears suspensions/fines history on stage transition."
            }
        },

        close: "Close",
        creating: "Creating...",
        create: "Create Sanction Rule",

        success: "Sanction rule created.",
        error: "Failed to create sanction rule."
    },
    sanctionRuleEditModal: {
        badge: "EDIT",
        title: "Edit Sanction Rule",
        subtitle: "Update accumulation, suspensions, and optional fines.",

        close: "Close",
        saving: "Saving...",
        saveChanges: "Save Changes",

        sections: {
            core: {
                title: "Core fields",
                hint: "Main configuration for the rule."
            },
            toggles: {
                title: "Resets & Overrides",
                hint: "Control how accumulation resets."
            },
            fines: {
                title: "Fines",
                hint: "Optional monetary penalties (leave blank for none)."
            }
        },

        fields: {
            ruleName: "Rule Name",
            ruleNamePlaceholder: "e.g., Standard FIFA Discipline",
            maxAccumulatedYellowCards: "Max Accumulated Yellow Cards",
            maxAccumulatedYellowCardsHint: "Maximum yellows allowed before accumulation suspension applies.",

            redCardSuspensionGames: "Red Card Suspension (games)",
            accumulatedYellowSuspensionGames: "Accumulated Yellow Suspension (games)",
            doubleYellowSuspensionGames: "Double Yellow Suspension (games)",

            yellowCardFine: "Yellow Card Fine ($)",
            yellowCardFinePlaceholder: "e.g., 10.00",
            doubleYellowFine: "Double Yellow Fine ($)",
            doubleYellowFinePlaceholder: "e.g., 25.00",
            redCardFine: "Red Card Fine ($)",
            redCardFinePlaceholder: "e.g., 50.00"
        },

        toggles: {
            resetOnRed: {
                title: "Reset yellow cards after red card",
                description: "Clears accumulated yellows when a red card is issued."
            },
            resetOnDoubleYellow: {
                title: "Reset yellow cards after double yellow",
                description: "Clears accumulation when a player is sent off via 2 yellows."
            },
            overrideAccumulation: {
                title: "Double yellow overrides accumulation sanction",
                description: "Prevents stacking double-yellow + accumulation penalty."
            },
            resetOnStageChange: {
                title: "Reset yellow cards on stage change",
                description: "Example: group stage → playoffs."
            },
            resetSanctionsOnStageChange: {
                title: "Reset sanctions on stage change",
                description: "Clears suspensions/fines history on stage transition."
            }
        }
    },
    stripeAccountsPage: {
        pageTitle: "Accounts",
        payments: "Payments",
        stripeAccounts: "Stripe Accounts",

        infoBadge: "INFO",
        infoTitle: "Stripe Connect fees and platform fee",
        infoSubtitle: "Estimate league net payout for a payment amount.",
        infoText1: "Payments processed through AngeonX Sports use Stripe Connect. Stripe typically charges",
        infoText2: "per transaction, and AngeonX Sports applies a",
        infoText3: "platform fee. These are deducted before payout to the league.",
        infoExample: "Example with a {amount} payment → League would net approximately {net}.",

        tableTitle: "Payout Accounts",
        tableSubtitle: "Manage Stripe Connect payout accounts for your organization.",
        tableHeaders: {
            name: "Name",
            email: "Email",
            country: "Country",
            details: "Details",
            last4: "Last4",
            status: "Status",
            actions: ""
        },

        noValue: "—",
        detailsSubmittedYes: "✅",
        detailsSubmittedNo: "❌",

        verified: "Verified",
        needsVerification: "Needs verification",
        completeVerification: "Complete Verification",
        completeVerificationTitle: "Complete onboarding requirements in Stripe",

        createTitle: "Create Stripe Account",
        close: "Close",

        onboardingLinkFailed: "Could not get onboarding link.",
        onboardingLinkError: "Error generating Stripe onboarding link"
    },
    createStripeAccountModal: {
        accountNickname: "Account Nickname",
        accountNicknamePlaceholder: "League Stripe Account",
        accountNicknameHelper: "A friendly label to identify this payout account inside AngeonX Sports.",

        country: "Country",
        countryPlaceholder: "Choose a country...",
        countryHelper: "This determines the Stripe Connect country for onboarding requirements.",

        cancel: "Cancel",
        creating: "Creating...",
        createAndOnboard: "Create & Onboard",

        redirecting: "Redirecting to Stripe onboarding...",
        onboardingLinkFailed: "Could not generate onboarding link.",
        enterNameWarning: "Please enter a name.",
        selectCountryWarning: "Please select a country.",
        somethingWentWrong: "Something went wrong"
    },
    stripeOnboardRetryPage: {
        brandAlt: "kBola Sports",
        title: "Stripe setup incomplete",
        message: "You didn’t complete the account setup. Please try again.",
        retry: "Try Again"
    },
    stripeOnboardSuccessPage: {
        brandAlt: "kBola Sports",
        title: "Stripe account setup completed!",
        message: "Your payout account is ready to receive funds."
    },
    subscriptionPage: {
        title: "Subscription Plans",
        subtitle: "Choose your billing cycle and subscription type. Prices display in your profile currency ({currency}).",

        billing: {
            monthly: "Monthly",
            yearly: "Yearly",
            yearlyOnly: "Yearly only",
            currency: "Currency"
        },

        audience: {
            individual: "Individual",
            organization: "Organization"
        },

        sections: {
            individualTitle: "Individual Subscriptions (Mobile App)",
            individualHint: "For players, coaches, and parents using the AngeonX Sports mobile app. Unlock advanced stats, lineup tools, game tracking, and premium in-app experiences.",
            organizationTitle: "Organization Subscriptions (Web Platform Management)",
            organizationHint: "For leagues, clubs, and academies. Manage seasons, schedules, sanctions, payments, and administrative tools from the AngeonX Sports web dashboard."
        },

        orgSelector: {
            badge: "Organization",
            title: "Select the organization that will receive this subscription",
            hint: "Only organizations you can manage are listed here. The subscription will be applied to the selected organization's web management tools.",
            placeholder: "-- Choose organization --"
        },

        plans: {
            current: "Current",
            bestValue: "Best Value",
            savePercent: "Save {percent}%",
            processing: "Processing...",
            selectOrganization: "Select organization",
            subscribe: "Subscribe",
            cancelSubscription: "Cancel subscription",
            noPriceAvailable: "No price available for your currency.",
            orgRequired: "Please select an organization for this subscription.",
            checkoutFailed: "Failed to create checkout session.",
            cancelFailed: "Error cancelling subscription"
        },

        options: {
            "plans": {
                "free": "Free",
                "pro": "Pro",
                "elite": "Elite",
                "trial": "Trial",
                "test": "Test",
                "enterprise": "Enterprise"
            },
            "features": {
                "elite_confirm_attendance": {
                    "label": "Confirm Attendance to Events",
                    "description": "Access to confirm attendance to events you are invited."
                },
                "free_limited_events": {
                    "label": "Only 2 Active Events",
                    "description": "You can see and interact with events you are invited to.\nYou can create up to 2 active events.\nYou can invite teammates to your events.\nYou cannot add external participants by email."
                },
                "free_in_app_notifications": {
                    "label": "Basic In-App Notifications",
                    "description": "Only basic in-app notifications when the app is active.\nNo push notifications when the app is closed or in the background."
                },
                "free_limited_chat": {
                    "label": "Limited Chat",
                    "description": "Limited chat.\nTeam chats only.\nStorage of the latest 50 messages per chat room.\nNo private chats."
                },
                "free_basic_preferences": {
                    "label": "Basic Preferences",
                    "description": "Basic preferences.\nNo sport preferences or preferred field positions.\nLow visibility in Connect."
                },
                "free_single_profile": {
                    "label": "One Profile Only",
                    "description": "You can only create and use one profile with this plan."
                },
                "free_single_team": {
                    "label": "Manage One Team Only",
                    "description": "Create and manage one team as a team manager under this plan."
                },
                "free_marketplace_features": {
                    "label": "Basic Connect",
                    "description": "Basic Connect.\nNo advanced filters to find players, referees, teams or organizations.\nNo exclusive MapView for distance or location filters.\nNo filters by sports preferences.\nLow visibility for your profile and team."
                },
                "free_push_notifications": {
                    "label": "No Push Notifications",
                    "description": "You will not receive push notifications for team or organization invitations.\nOnly limited in-app notifications are available."
                },
                "free_no_referee_reviews": {
                    "label": "No Referee/Umpire Reviews",
                    "description": "No access to rate referees/umpires or view their reviews."
                },
                "free_no_ai": {
                    "label": "No AI Suggestions",
                    "description": "No AI features.\nNo organization/team/tournament suggestions based on stats or preferences.\nNo AI win-probability forecasts."
                },
                "free_no_performance_insights": {
                    "label": "No Performance Insights with AI",
                    "description": "No performance insights with AI.\nNo tips to improve or elevate your career."
                },
                "free_no_streams_highlights": {
                    "label": "No Access to Game Streams & Highlights",
                    "description": "You cannot watch live-streamed games or highlight reels for events you’re connected to, including your teams, leagues, and followed players."
                },
                "free_no_custom_support": {
                    "label": "No Custom Support",
                    "description": "This plan does not include access to custom or personalized support."
                },
                "pro_manage_events": {
                    "label": "Manage Own Events",
                    "description": "Fully manage your own events.\nCreate unlimited events.\nInvite extra participants by email."
                },
                "pro_receive_push_notifications": {
                    "label": "Receive Push Notifications",
                    "description": "Receive push notifications for certain activities related to your events, teams, results, and invitations."
                },
                "pro_full_chat": {
                    "label": "Full Chat",
                    "description": "Full chat access.\nTeam chats.\nPrivate chats."
                },
                "pro_referee_reviews": {
                    "label": "Referee/Umpire Reviews",
                    "description": "Rate referee/umpire performance.\nView referee/umpire reviews."
                },
                "pro_advanced_preferences": {
                    "label": "Advanced Preferences",
                    "description": "Full preferences on your profiles.\nLet managers and scouts know your preferred sports and positions on the field.\nHelp them find you more easily."
                },
                "pro_detailed_results": {
                    "label": "Detailed & Live Results for Games",
                    "description": "Detailed and live results for games.\nEnter individual player stats.\nManage sanctions in your organizations.\nReal-time gamecast updates during the game."
                },
                "social_media_sharable": {
                    "label": "Share on Social Media",
                    "description": "Share results, standings, schedules, and events on social media."
                },
                "pro_multi_profiles_limited": {
                    "label": "Manage up to 3 Profiles",
                    "description": "Create and manage up to 3 profiles under your account."
                },
                "pro_team_management_limited": {
                    "label": "Manage up to 3 Teams",
                    "description": "Create and manage up to 3 teams under your account."
                },
                "pro_marketplace_features": {
                    "label": "Connect for a Pro",
                    "description": "Full Connect filters.\nSports filters.\nLocation filters.\nMapView for faster searching.\nMedium visibility in Connect."
                },
                "pro_custom_support": {
                    "label": "Pro Custom Support",
                    "description": "Access to basic custom support.\nReport system issues and get them solved.\nRequest tutorial documents and videos.\nNo live chat support."
                },
                "elite_marketplace_features": {
                    "label": "Connect for Elite Players",
                    "description": "Full Connect access.\nFull filters.\nHigh visibility for your profiles and teams.\nManagers and scouts will find you faster than ever."
                },
                "elite_ai_win_forecast": {
                    "label": "AI Forecast: Win Probability",
                    "description": "Game result predictions.\nWin probability based on previous stats, team records, and opponent."
                },
                "elite_profile_performance_insights": {
                    "label": "Performance with AI Insights for Players",
                    "description": "Receive tips and performance insights powered by AI analysis."
                },
                "elite_streams_highlights": {
                    "label": "Access Game Streams & Highlights",
                    "description": "Access game streams and highlights.\nEnjoy recaps or live full games."
                },
                "elite_chat_support": {
                    "label": "Personalized Support",
                    "description": "Full personalized support.\nReport issues and get them solved ASAP.\nRequest tutorials and videos.\nLive chat support."
                },
                "elite_multi_profiles_unlimited": {
                    "label": "Unlimited Profiles",
                    "description": "Create as many profiles as you want.\nNo profile limits."
                },
                "elite_team_management_unlimited": {
                    "label": "Unlimited Team Management",
                    "description": "Create as many teams as you want.\nNo team limits."
                },
                "free_single_organization": {
                    "label": "One Organization Only",
                    "description": "Manage one organization only with this plan."
                },
                "free_limited_divisions": {
                    "label": "Up to 3 Divisions/Categories",
                    "description": "Create and manage up to 3 divisions or categories."
                },
                "free_limited_seasons": {
                    "label": "One Season per Division/Category",
                    "description": "Create and manage up to 1 season per division or category."
                },
                "free_ai_scheduling": {
                    "label": "AI-Powered Scheduling",
                    "description": "Generate optimized game schedules in seconds using AI. Automatically resolve conflicts, assign referees, and balance fields and match times based on team availability, locations, and league rules."
                },
                "free_global_results": {
                    "label": "Global Game Results",
                    "description": "Enter global game results.\nResults are entered after the game.\nNo individual stats.\nNo detailed results per game."
                },
                "free_no_print_results": {
                    "label": "Basic Shareable and Printable Schedule",
                    "description": "Manage schedules in the platform.\nPrint and share a generic schedule and game sheet."
                },
                "free_no_import_export_schedule": {
                    "label": "No Schedule Import or Export",
                    "description": "No access to import or export schedules."
                },
                "free_basic_notifications": {
                    "label": "Basic Notifications",
                    "description": "Automatic basic notifications to managers and referees/umpires.\nSchedule created.\nGame changes."
                },
                "pro_limited_management": {
                    "label": "Manage 5 Divisions and Unlimited Seasons",
                    "description": "Create and manage up to 5 divisions and unlimited seasons."
                },
                "pro_print_schedule": {
                    "label": "Custom Printable and Shareable Schedule",
                    "description": "Printable and shareable professional schedules by sport using AngeonX Sports formats."
                },
                "pro_automatic_notifications": {
                    "label": "Notify Everyone",
                    "description": "Send notifications to all involved participants when a schedule is created or updated."
                },
                "pro_push_notifications": {
                    "label": "Notification Module",
                    "description": "Access the notification module.\nSend custom notifications to managers and referees/umpires in your organizations."
                },
                "elite_full_notifications": {
                    "label": "Full Notification Module",
                    "description": "Access the notification module.\nSend custom notifications to your organizations.\nInclude filters and segmentation."
                },
                "elite_ai_result_forecast": {
                    "label": "AI Forecast: Win Probability for Organizations",
                    "description": "Use AI to forecast win probabilities for upcoming organization matches based on past performance, opponent stats, and historical trends."
                },
                "elite_stream_games": {
                    "label": "Stream Games & Highlights",
                    "description": "Broadcast games live and upload highlights from the field. Let families, fans, and scouts watch matches in real time or catch up with key moments in the app."
                },
                "elite_download_game_stats": {
                    "label": "Download Game Stats",
                    "description": "Export detailed stats and game summaries to PDF or Excel for review or sharing."
                },
                "elite_custom_branding": {
                    "label": "Custom Branding",
                    "description": "Add your organization logo, colors, and branding to schedules, results, and profile pages.\nIncludes a dedicated landing page for your organization."
                },
                "elite_referee_management_dashboard": {
                    "label": "Referee Management Tools",
                    "description": "Manage assignments, track availability, and collect performance ratings for referees and umpires."
                },
                "free_standing": {
                    "label": "Basic Standings",
                    "description": "Basic standings for organizations.\nNo sanction points in standings.\nNo bonus points in standings."
                },
                "pro_standing": {
                    "label": "Pro Standings Features",
                    "description": "Pro standings for organizations.\nIncludes sanction and bonus points."
                },
                "waiver_management": {
                    "label": "Waiver Management",
                    "description": "Manage waivers for organizations, divisions, seasons, and teams."
                },
                "sanction_management": {
                    "label": "Sanction Management",
                    "description": "Manage sanction rules for organizations, divisions, seasons, and teams."
                },
                "venues_management": {
                    "label": "Venues & Facilities Management",
                    "description": "Manage venues and facilities for organizations, divisions, seasons, and teams."
                },
                "entity_picture": {
                    "label": "Entity Picture",
                    "description": "Upload a picture for an organization, division, season, or team."
                },
                "elite_live_results": {
                    "label": "Live Game Results",
                    "description": "Detailed and live results for games.\nEnter individual player stats.\nManage sanctions in your organizations.\nBroadcast live game results in real time."
                },
                "elite_limited_organizations": {
                    "label": "Unlimited Divisions and Seasons",
                    "description": "Create and manage unlimited divisions and seasons."
                },
                "enterprise_chat_support": {
                    "label": "Full Prioritized Support",
                    "description": "Access full personalized and prioritized support.\nReport system issues and get them solved ASAP.\nRequest tutorial documents and videos.\nLive chat support."
                },
                "chat_media_messages": {
                    "label": "Chat Media Messages",
                    "description": "Send and view media files, including images, in chat messages."
                },
                "enterprise_organizations_unlimited": {
                    "label": "Unlimited Divisions and Seasons",
                    "description": "Create and manage unlimited divisions and seasons."
                },
                "manage_player_picture": {
                    "label": "Manage Player Pictures",
                    "description": "Allow organization managers to upload pictures for their players."
                },
                "manage_team_players": {
                    "label": "Manage Team Players",
                    "description": "Allow organization managers to manage players on teams."
                },
                "enterprise_user_management": {
                    "label": "Manage Users",
                    "description": "Create users, assign players, coaches, and coordinators, send activation emails, and import organization structures."
                },
                "import_schedule_from_file": {
                    "label": "Import Schedule from .xlsx File",
                    "description": "Allow organization managers to import schedules from .xlsx files."
                },
                "in_app_advertising": {
                    "label": "In-App Advertising",
                    "description": "Allow organizations to use in-app advertising to promote events, activities, and sponsor products."
                },
                "event_sync_calendar": {
                    "label": "Sync Events with Calendar",
                    "description": "Sync your events with your device calendar."
                },
                "pro_event_photos": {
                    "label": "Event Photos",
                    "description": "Allow users to add up to 3 photos per event."
                },
                "elite_event_photos": {
                    "label": "Event Photos",
                    "description": "Allow users to add up to 5 photos per event."
                },
                "enterprise_event_photos": {
                    "label": "Event Photos",
                    "description": "Allow users to add up to 10 photos per event."
                },
                "marketplace_manage_listing_free": {"label": "Manage up to 3 Marketplace listings", "description": "Create and manage up to 3 active sports marketplace listings."},
                "marketplace_manage_listing_pro": {"label": "Manage up to 10 Marketplace listings", "description": "Create and manage up to 10 active sports marketplace listings."},
                "marketplace_manage_listing_elite": {"label": "Unlimited Marketplace listings", "description": "Create and manage unlimited active sports marketplace listings."},
                "enterprise_marketplace_buy_sell_listings": {"label": "Unlimited Marketplace listings", "description": "Create and manage unlimited active sports marketplace listings for your organization."},
                "marketplace_manage_listing_trial": {"label": "Manage up to 3 Marketplace listings", "description": "Create and manage up to 3 active sports marketplace listings during your trial."}
            }
        },

        billingSuffix: {
            month: "/ month",
            year: "/ year"
        },

        confirmCancel: {
            title: "Confirm to cancel",
            message: "You are about to cancel your current subscription. Are you sure to do this?",
            yes: "Yes",
            no: "No"
        },

        customPlan: {
            title: "Need a tailored subscription?",
            body1: "Whether you run a small local academy or a multi-league organization, we know every structure and budget is different.",
            body2: "If our standard plans feel too big, too small, or too expensive for your reality, reach out and we’ll work with you on an adjusted solution that fits your needs.",
            body3: "Contact us at",
            body4: "and we’ll help you find the right setup. You can also request a",
            freeTrial: "FREE trial account"
        },

        accessibility: {
            featureLevel: "Feature level {level} out of {total}"
        }
    },
    invoicesPage: {
        title: "Subscription Invoices",
        subtitle: "Invoices for your mobile plan. Dates shown in your local timezone ({timezone}).",

        actions: {
            refresh: "Refresh"
        },

        table: {
            title: "Invoices",
            headers: {
                subscription: "Subscription",
                type: "Type",
                status: "Status",
                amountPaid: "Amount Paid",
                amountDue: "Amount Due",
                period: "Period",
                view: "View"
            }
        },

        status: {
            paid: "PAID",
            open: "OPEN"
        }
    },
    organizations: {
        "pageTitle": "Organizations",

        "removeSuccess": "Organization was removed successfully",
        "removeFailed": "Failed to remove organization",
        "removeError": "Error removing organization",

        "confirmArchiveTitle": "Archive Organization?",
        "confirmArchiveMessage": "This will archive the organization and related data: divisions, seasons, teams, players, stats, etc. Are you sure?",
        "confirmArchive": "Archive",
        "cancel": "Cancel",

        "locationFallback": "Manage divisions, seasons, teams and stats in one place.",

        "divisions": "Divisions",
        "seasons": "Seasons",
        "teams": "Teams",

        "openDivisions": "Open divisions",
        "downloadImportTemplate": "Download import template",
        "downloadingImportTemplate": "Preparing template...",
        "importTemplateDownloaded": "Import template downloaded",
        "importTemplateDownloadError": "Unable to download the import template.",
        "importExistingData": "Import existing data",
        "importDataBadge": "DATA",
        "closeImport": "Close",
        "importMappingHint": "Upload an Excel or CSV file. We will read each entity sheet and suggest mappings before any data is imported.",
        "sourceColumn": "Source column",
        "kbolaField": "AngeonX Sports field",
        "sampleValue": "Sample value",
        "ignoreColumn": "Ignore column",
        "missingRequiredFields": "Missing required fields",
        "requiredFieldsMapped": "All required fields are mapped for this sheet.",
        "validateMapping": "Validate mapping",
        "importUnsupportedFile": "Please select an Excel or CSV file.",
        "importNoSheets": "No importable sheets were found.",
        "importFileParsed": "File parsed. Review the column mappings.",
        "importParseError": "Unable to parse the import file.",
        "importMissingRequiredFields": "Map all required fields before continuing.",
        "importMappingReady": "Mapping is ready for the import step.",
        "validatingMapping": "Validating...",
        "importValidationError": "Unable to validate the import mapping.",
        "importRowValidationError": "Review the highlighted rows before continuing.",
        "importRowErrors": "Rows needing attention",
        "importRowErrorsShort": "errors",
        "importRowLabel": "Row {{row}}:",
        "importStructure": "Import structure",
        "importingStructure": "Importing structure...",
        "importStructureSuccess": "All reviewed organization data was imported.",
        "importStructureError": "Unable to import the organization structure.",
        "sendActivationEmails": "Send activation emails",
        "sendingActivationEmails": "Sending activation emails...",
        "activationEmailsSent": "Activation emails sent.",
        "activationEmailsError": "Unable to send activation emails.",
        "manageActivations": "Manage activations",
        "activationPanelTitle": "Imported user activation",
        "activationPanelHint": "We’ll send an activation email so each user can set a password and access the platform.",
        "pendingActivations": "pending activations",
        "sendAllActivations": "Send activation email",
        "loadingActivations": "Loading activation status...",
        "noPendingActivations": "All imported accounts are activated.",
        "activationAccount": "Account",
        "activationType": "Role",
        "activationStatusLabel": "Status",
        "activationAction": "Action",
        "activationAccountType": "Account type",
        "resendActivation": "Resend",
        "sendActivationEmail": "Send activation email",
        "activationSent": "Activation email sent.",
        "activationPartial": "{{count}} activation email(s) sent; some accounts could not be reached.",
        "activationSendError": "Unable to send this activation email.",
        "activationLoadError": "Unable to load activation status.",
        "searchActivations": "Search by name or email",
        "clearSearch": "Clear search",
        "activationLastSent": "Last email",
        "confirmSendActivations": "Send activation emails to all pending users?",
        "confirmResendActivation": "Send an activation email to this user?",
        "refreshActivations": "Refresh activation status",
        "createUserTitle": "Create user and send activation",
        "createUserSubtitle": "The user will receive an email to set a password and access the platform.",
        "createUserOrganization": "Organization",
        "createUserChooseOrganization": "Choose an organization",
        "createUserRole": "Role",
        "createUserRoles": {"player": "Player", "coach": "Coach", "coordinator": "Coordinator", "referee": "Referee / Umpire"},
        "createUserFirstName": "First name", "createUserLastName": "Last name", "createUserEmail": "Email", "createUserMobile": "Mobile", "createUserDob": "Date of birth",
        "createUserSaving": "Creating user...", "createUserSubmit": "Create and send activation", "createUserActivationSent": "User created and activation email sent.", "createUserExistingAccount": "Existing user added successfully.", "createUserError": "Unable to create the user.",
        "createUserOptional": "optional",
        "activationFilters": {"all": "All", "player": "Players", "coach": "Coaches", "referee": "Referees"},
        "activationStatus": {"pending": "Pending", "sent": "Sent", "activated": "Activated"},
        "chooseImportFile": "Choose a file to import",
        "importSupportedFiles": "Excel workbooks may contain multiple entity sheets; CSV files contain one sheet.",
        "parsingImportFile": "Reading file...",
        "chooseFile": "Choose file",
        "noImportFile": "No file selected",
        "importFileHint": "Supported formats: .xlsx, .xls, .csv",
        "clearImport": "Clear selected file",
        "importSheets": "Import sheets",
        "importPreview": "Data preview",
        "importPreviewLimit": "Showing the first 10 rows",
        "importReviewSummary": "Import review summary",
        "importSummarySheets": "sheets",
        "importSummaryRows": "rows",
        "importSummaryErrors": "errors",
        "importFields": {
            "externalId": "External ID", "divisionExternalId": "Division external ID", "division": "Division", "name": "Name", "description": "Description", "sport": "Sport", "mountDistance": "Mount distance", "pitchLimit": "Pitch limit", "restingGames": "Resting games", "gameDuration": "Game duration", "registrationStartDate": "Registration start date", "registrationEndDate": "Registration end date", "startDate": "Start date", "endDate": "End date", "lateRegistrationUntil": "Late registration until", "state": "State", "registrationFeeType": "Registration fee type", "lateRegistrationFee": "Late registration fee", "seasonExternalId": "Season external ID", "season": "Season", "scheduleType": "Schedule type", "minGamesRequired": "Minimum games required", "gamesMode": "Games mode", "qtyTeamsQualified": "Qualified teams", "qtyTeamsAdditional": "Additional teams", "stageExternalId": "Stage external ID", "stage": "Stage", "teamExternalId": "Team external ID", "team": "Team", "teamAliasName": "Team alias", "email": "Email", "mobile": "Mobile", "firstName": "First name", "lastName": "Last name", "dob": "Date of birth", "gender": "Gender", "shirtNumber": "Shirt number", "position": "Position", "note": "Note", "isActive": "Active", "status": "Status", "contact": "Email or mobile"
        },
        "upgrade": "Upgrade",
        "coordinators": "Coordinators",

        "brandingTheme": "Branding & Theme",
        "editOrganization": "Edit organization",
        "archiveOrganization": "Archive organization",

        "planFree": "Free",
        "planTrial": "Trial",
        "planPaid": "Paid"
    },
    addOrganization: {
        "title": "New Organization",
        "newBadge": "NEW",
        "close": "Close",
        "save": "Save",

        "basics": "Basics",
        "logoLabel": "Organization logo (optional)",
        "logoHint": "Recommended: 1:1 ratio, PNG or JPG",
        "name": "Name",
        "namePlaceholder": "Organization name",
        "organizationType": "Organization Type",
        "typeLeague": "League / Tournament",
        "typeAcademy": "Academy / School",
        "organizationTypeHint": "This helps AngeonX Sports tailor defaults (divisions, seasons, rules) for the organization.",

        "location": "Location",
        "address": "Address",
        "addressPlaceholder": "Search for a location",
        "addressHint": "Used for maps, travel distance, and local discovery. You can change it later.",

        "venues": "Venues",
        "availableFields": "Available Fields",
        "selectedFields": "Selected Fields",

        "billing": "Billing",
        "currency": "Currency",
        "selectCurrency": "— Select currency —",
        "currencyHint": "Currency will apply to fees, invoices, and payouts for this organization.",
        "stripeAccount": "Stripe Payout account (optional, only for online payments)",
        "noAccount": "— No account —",
        "stripeAccountHint": "If you plan to accept online payments, connect a Stripe payout account later or select one now.",

        "pleaseEnterText": "Please enter text",
        "noActiveProfile": "No active profile selected.",
        "createError": "Error creating organization.",
        "createdSuccess": "Organization created successfully",
        "logoUploadFailedWithErrors": "Organization created, but logo upload failed: {{errors}}",
        "logoUploadFailedWithMessage": "Organization created, but logo upload failed: {{message}}",
        "selectActiveProfileFirst": "Select an active profile first",
        "createOrganization": "Create organization"
    },
    editOrganization: {
        "title": "Edit Organization",
        "editBadge": "EDIT",
        "close": "Close",
        "save": "Save",
        "saving": "Saving...",
        "saveChanges": "Save changes",

        "basics": "Basics",
        "logoLabel": "Organization logo (optional)",
        "logoHint": "Recommended: 1:1 ratio, PNG or JPG",
        "name": "Name",
        "namePlaceholder": "Organization name",
        "organizationType": "Organization Type",
        "typeLeague": "League / Tournament",
        "typeAcademy": "Academy / School",
        "organizationTypeHint": "This helps AngeonX Sports tailor defaults (divisions, seasons, rules) for the organization.",

        "location": "Location",
        "address": "Address",
        "addressPlaceholder": "Search for a location",
        "addressHint": "Used for maps, travel distance, and local discovery.",

        "venues": "Venues",
        "availableFields": "Available Fields",
        "selectedFields": "Selected Fields",

        "policiesAndRules": "Policies & Rules",
        "waiverOptional": "Waiver (optional)",
        "noWaiver": "— No waiver —",
        "sanctionRuleOptional": "Sanction Rule (optional for soccer)",
        "noRule": "— No rule —",

        "billing": "Billing",
        "currency": "Currency",
        "selectCurrency": "— Select currency —",
        "currencyHint": "Currency applies to fees, invoices, and payouts for this organization.",
        "stripeAccount": "Stripe Payout account (optional, only for online payments)",
        "noAccount": "— No account —",
        "stripeAccountHint": "If you plan to accept online payments, connect a Stripe payout account later or select one now.",

        "updatedSuccess": "Organization updated successfully",
        "logoUploadFailedWithErrors": "Organization updated, but logo upload failed: {{errors}}",
        "logoUploadFailedWithMessage": "Organization updated, but logo upload failed: {{message}}",
        "noDetailsForInput": "No details available for input: '{{name}}'"
    },
    filePicker: {
        "ariaLabel": "File picker",
        "chooseFile": "Choose file",
        "existingImage": "Existing image",
        "noFileSelected": "No file selected",
        "dragDropHint": "Drag & drop a square logo here (PNG/JPG). Recommended 1:1.",
        "remove": "Remove",
        "logoPreview": "Logo preview",
        "preview": "Preview"
    },
    editOrganizationBranding: {
        "badge": "BRANDING",
        "title": "Branding & Theme – {{name}}",
        "close": "Close",
        "save": "Save",
        "saving": "Saving...",
        "saveBranding": "Save branding",
        "updateFailed": "Failed to update branding",
        "updatedSuccess": "Branding updated successfully",

        "identity": "Identity",
        "logoLabel": "Branding logo (optional)",
        "logoHint": "This logo is used in the branded portal header and hero. Recommended: PNG with transparent background.",
        "subdomain": "Subdomain",
        "subdomainPlaceholder": "my-league",
        "subdomainHint": "This becomes the branded URL, for example: {{subdomain}}.kbolasport.com",
        "enablePortal": "Enable branded portal for this organization",

        "brandColors": "Brand Colors",
        "primary": "Primary",
        "secondary": "Secondary",
        "accent": "Accent",
        "resetDefaults": "Reset to AngeonX Sports defaults",
        "brandColorsHint": "These colors drive buttons, highlights, and key accents in the branded portal.",

        "backgroundSurface": "Background & Surface",
        "background": "Background",
        "surface": "Surface",
        "border": "Border",
        "backgroundSurfaceHint": "Background is the main page color; surface is used for cards and panels.",

        "textColors": "Text Colors",
        "textOnBackground": "Text on background",
        "textOnSurface": "Text on surface",
        "textOnPrimary": "Text on primary",
        "textOnSecondary": "Text on secondary",

        "backgroundPreview": "Background preview",
        "backgroundPreviewTitle": "AngeonX Sports – Background",
        "backgroundPreviewText": "This is how standard text will look on your main page color.",

        "primaryPreview": "Primary button preview",
        "primaryPreviewTitle": "Call-to-action / Primary",
        "primaryPreviewText": "Make sure this remains readable for buttons and highlights."
    },
    divisions: {
        "pageTitle": "Divisions",
        "organizationFallback": "Organization",

        "archiveSuccess": "Division was archived successfully",
        "archiveFailed": "Failed to archive division",
        "archiveError": "Error archiving division",
        "loadError": "Failed to load divisions",

        "confirmArchiveTitle": "Archive this division?",
        "confirmArchiveMessage": "This will archive the division and ALL related data: seasons, teams, players, stats, etc. Are you sure?",
        "archive": "Archive",
        "cancel": "Cancel",

        "sport": "Sport",
        "sportFallback": "Sport",
        "open": "Open",
        "closed": "Closed",
        "allStatuses": "All",
        "filterByStatus": "Filter divisions by status",

        "organizationLabel": "Organization",
        "seasonStart": "Season Start",
        "seasonEnd": "Season End",
        "season": "Season",
        "noneActive": "None active",
        "noActiveSeasonConfigured": "No active season configured",

        "openDetails": "Open division details",
        "details": "Details",
        "editDivision": "Edit division",
        "archiveDivision": "Archive division"
    },
    addDivision: {
        "newBadge": "NEW",
        "title": "New Division",
        "close": "Close",
        "save": "Save",

        "basics": "Basics",
        "name": "Name",
        "namePlaceholder": "Division name",
        "competitionLevel": "Competition level",
        "competitionLevelPlaceholder": "e.g. recreational, competitive",
        "optionalSelection": "— Optional —",
        "competitionOptions": {"recreational": "Recreational", "competitive": "Competitive", "select": "Select", "elite": "Elite"},
        "ageGroup": "Age group",
        "ageGroupPlaceholder": "e.g. U12, U14",
        "ageOptions": {"u8": "U8", "u10": "U10", "u12": "U12", "u14": "U14", "u16": "U16", "u18": "U18", "adult": "Adult", "senior": "Senior"},
        "sport": "Sport",
        "chooseSport": "— Choose sport —",
        "sportHint": "Sport affects defaults and available rules for this division.",

        "rules": "Rules",
        "mountDistance": "Mount Distance (ft)",
        "mountDistancePlaceholder": "e.g. 60.5",
        "mountDistanceHint": "Used for pitch tracking and game setup.",
        "pitchLimit": "Pitch Limit",
        "pitchLimitPlaceholder": "e.g. 75",
        "restingGames": "Resting Games",
        "restingGamesPlaceholder": "e.g. 1",
        "restingGamesHint": "How many games a pitcher must rest after reaching the pitch limit.",
        "gameDuration": "Game Duration (minutes)",
        "gameDurationPlaceholder": "e.g. 90",

        "policy": "Policy",
        "waiverOptional": "Waiver (optional)",
        "noWaiver": "— No waiver —",
        "waiverHint": "Attach a waiver for participants in this division (can be changed later).",

        "createdSuccess": "Division created successfully",
        "error": "Error creating division"
    },
    editDivision: {
        "editBadge": "EDIT",
        "title": "Edit Division",
        "close": "Close",
        "save": "Save",
        "saving": "Saving...",

        "basics": "Basics",
        "name": "Name",
        "competitionLevel": "Competition level",
        "competitionLevelPlaceholder": "e.g. recreational, competitive",
        "optionalSelection": "— Optional —",
        "competitionOptions": {"recreational": "Recreational", "competitive": "Competitive", "select": "Select", "elite": "Elite"},
        "ageGroup": "Age group",
        "ageGroupPlaceholder": "e.g. U12, U14",
        "ageOptions": {"u8": "U8", "u10": "U10", "u12": "U12", "u14": "U14", "u16": "U16", "u18": "U18", "adult": "Adult", "senior": "Senior"},
        "sport": "Sport",
        "chooseSport": "— Choose sport —",
        "sportHint": "Changing sport may affect rules and defaults.",

        "rules": "Rules",
        "mountDistance": "Mount Distance (ft)",
        "mountDistancePlaceholder": "e.g. 60.5",
        "pitchLimit": "Pitch Limit",
        "pitchLimitPlaceholder": "e.g. 75",
        "restingGames": "Resting Games",
        "restingGamesPlaceholder": "e.g. 1",
        "gameDuration": "Game Duration (minutes)",
        "gameDurationPlaceholder": "e.g. 90",

        "policy": "Policy",
        "waiverOptional": "Waiver (optional)",
        "noWaiver": "— No waiver —",
        "waiverHint": "Used for participant agreement within this division.",

        "editedSuccess": "Division edited successfully",
        "error": "Error editing division"
    },
    divisionDetailPage: {
        "pageTitle": "Division Details",
        "breadcrumbOrganizations": "Organizations",
        "breadcrumbDivisions": "Divisions"
    },
    "divisionHeader": {
        "badge": "Division",
        "subtitle": "Quick overview of sport and active season context.",
        "open": "Open",
        "closed": "Closed",
        "sport": "Sport",
        "season": "Season",
        "divisionStatus": "Division Status",
        "active": "Active",
        "archived": "Archived",
        "empty": "—"
    },
    "activeSeason": {
        "badge": "Seasons",
        "title": "Season Management",
        "subtitle": "Select the active season for this division.",
        "newSeason": "New season",
        "newSeasonTitle": "Create a new season",
        "lockedTitle": "Locked while reviewing an old season",
        "activeSeasonLabel": "Active Season",
        "selectSeasonPlaceholder": "— Select a season —",
        "hint": "Changing the active season updates stages and teams for scheduling and stats.",
        "itemLabel": "seasons"
    },
    "divisionSummary": {
        "stages": "Stages",
        "teams": "Teams",
        "events": "Events",
        "players": "Players",
        "competitionPhases": "Competition phases",
        "registeredTeams": "Registered teams",
        "scheduledGames": "Scheduled games",
        "activeRosterSize": "Active roster size"
    },
    "divisionTags": {
        "title": "Division workspace",
        "premiumNotice": "Tabs Stats and Adjustments are only available for premium plans.",
        "pro": "PRO",
        "basic": "BASIC",
        "teams": "Teams",
        "stages": "Stages",
        "seasons": "Seasons",
        "schedule": "Schedule",
        "standings": "Standings",
        "sanctions": "Sanctions",
        "stats": "Stats",
        "pointAdjustments": "Point Adjustments",
        "divisionTabsAriaLabel": "Division tabs",
        "loading": "Loading…",
        "comingSoon": "Coming soon"
    },
    "teamList": {
        "removeSuccess": "Team removed successfully",
        "removeFailed": "Failed to remove team",
        "removeTitle": "Remove this team from the season?",
        "removeMessageLine1": "This will unlink \"{{teamName}}\" from this season.",
        "removeMessageLine2": "Players, stats, and schedule for that team in this season may be affected.",
        "removeMessageLine3": "Are you sure?",
        "removeConfirm": "Remove Team",
        "cancel": "Cancel",
        "proOnlyFeature": "This feature is available for Pro/Elite subscribers only.",
        "title": "Season Teams",
        "subtitleSeasonFallback": "this season",
        "total": "Total",
        "createTeam": "Create a team",
        "addExistingTeams": "Add existing teams",
        "headers": {
            "team": "Team",
            "players": "Players",
            "actions": "Actions"
        },
        "seasonTeam": "Season team",
        "openTeamDetails": "Open team details",
        "playersLinked": "Players linked to the team",
        "editTeamName": "Edit team name",
        "removeTeamFromSeason": "Remove team from season",
        "allSelectedAlreadyAdded": "All selected teams are already in this season.",
        "addExistingFailed": "Failed to add existing teams.",
        "teamsAndPlayersCopied": "Teams and players copied into this season.",
        "teamsAdded": "Teams added to this season."
    },
    "addTeamModal": {
        "teamAddedSuccess": "Team added successfully",
        "teamNameRequired": "Please enter a team name.",
        "teamCreatedLogoFailed": "Team created, but logo upload failed: {{errors}}",
        "badge": "New",
        "title": "Add Team",
        "closeAria": "Close",
        "closeTitle": "Close",
        "sectionTitle": "Team Details",
        "logoLabel": "Team logo (optional)",
        "logoHint": "Recommended: 1:1 ratio, PNG or JPG",
        "teamNameLabel": "Team name",
        "teamNamePlaceholder": "Type team name...",
        "teamNameHint": "This will create a team and link it to the current season.",
        "close": "Close",
        "noActiveSeasonSelected": "No active season selected",
        "addTeamTitle": "Add team",
        "saving": "Saving...",
        "save": "Save"
    },
    "editTeamModal": {
        "missingTeamId": "Missing team id.",
        "teamUpdatedLogoFailed": "Team updated, but logo upload failed: {{errors}}",
        "teamEditedSuccess": "Team edited successfully",
        "badge": "Edit",
        "title": "Edit Team",
        "closeAria": "Close",
        "closeTitle": "Close",
        "sectionTitle": "Team Details",
        "logoLabel": "Team logo (optional)",
        "logoHint": "Recommended: 1:1 ratio, PNG or JPG",
        "nameLabel": "Name",
        "namePlaceholder": "Team name",
        "nameHint": "This updates the team name across the web admin views.",
        "close": "Close",
        "save": "Save"
    },
    "addExistingSeasonTeamsModal": {
        "allSports": "All sports",
        "badge": "Copy",
        "title": "Add Existing Teams",
        "closeAria": "Close",
        "closeTitle": "Close",
        "sectionTitle": "Source season & teams",
        "includeArchivedDivisions": "Include archived divisions",
        "includeArchivedDivisionsTitle": "Show archived / inactive divisions as well",
        "sport": "Sport",
        "sourceDivision": "Source division",
        "loadingDivisions": "Loading divisions...",
        "selectDivision": "Select a division",
        "noDivisionsAvailable": "No divisions available",
        "couldNotLoadDivisions": "Could not load divisions. Please try again later.",
        "sourceSeason": "Source season",
        "selectSeason": "Select a season",
        "noSeasonsAvailable": "No seasons available",
        "sourceSeasonHint": "Choose the season you want to copy teams from. Usually this is last year's season.",
        "keepPlayersTitle": "Add players within the team to the season",
        "keepPlayersHint": "Optional. If enabled, players will also be copied into the active season for the selected teams.",
        "keepPlayersWarning": "DON'T MARK THIS IF YOU WANT PLAYERS TO REGISTER IN NEW SEASON!",
        "keepPlayersRequiredForMove": "Required when removing from the source season. Players and managers will be copied to the target season.",
        "keepPlayersTitleAttr": "Copy players into the active season",
        "transferOptionsTitle": "Transfer options",
        "targetStage": "Target stage",
        "targetGroup": "Target group",
        "sourceStage": "Source stage",
        "sourceGroup": "Source group",
        "selectStage": "Select a stage",
        "selectGroupOptional": "No group / choose later",
        "noStagesAvailable": "No stages available",
        "noGroupsAvailable": "No groups available",
        "carryPointsTitle": "Carry standings points",
        "carryPointsHint": "Copies the source standing points as a manual adjustment in the target stage/group.",
        "deactivateSourceTitle": "Remove from source season after transfer",
        "deactivateSourceHint": "Keeps the historical data, but deactivates the team in the source season. The backend blocks this if open games exist.",
        "pleaseWaitTitle": "Please wait until the operation finishes",
        "table": {
            "team": "Team",
            "players": "Players",
            "status": "Status"
        },
        "noTeamsForSeason": "No teams found for this season.",
        "selectSeasonToSeeTeams": "Select a season to see its teams.",
        "seasonTeam": "Season team",
        "alreadyInSeason": "Already in {{seasonName}}",
        "selected": "Selected",
        "available": "Available",
        "teamsSelectedFooter": "{{count}} team(s) selected to add.",
        "selectTeamsFooter": "Select one or more teams to add to the active season.",
        "close": "Close",
        "adding": "Adding...",
        "addSelectedTeams": "Add selected teams"
    },
    "inviteLinkBox": {
        "emailSubject": "Join our league on AngeonX Sports",
        "emailBody": "Hi, join our league on AngeonX Sports with this invite link:\n\n{{inviteURL}}\n\nIf you need to create an account, use the same link first. After you sign in, AngeonX Sports will take you back to the invitation automatically.",
        "whatsAppMessage": "Join our league on AngeonX Sports. Open this invite link to sign in or create an account; after sign in, the app will continue to the invitation automatically: {{inviteURL}}",
        "title": "Season Invite Link!",
        "description": "Share this link with team managers so they can register their teams in your league. If they need to create an account, AngeonX Sports will bring them back to this invitation after sign in. Only team <b>Managers/Captains</b> with an active team, <b>Referees/Umpires</b> or <b>League Coordinators</b> will be able to join using this invite link:",
        "copyLink": "📋 Copy Link",
        "sendEmail": "📧 Send Email",
        "whatsApp": "💬 WhatsApp",
        "important": "Important: Once you have every team registered, you can create <b>Stages</b> and <b>Schedule</b>."
    },
    "teamDetailPage": {
        "pageTitle": "Team Details",
        "breadcrumbOrganizations": "Organizations",
        "breadcrumbDivisions": "Divisions"
    },
    "teamHeader": {
        "division": "Division",
        "players": "Players",
        "season": "Season"
    },
    "inviteTeamLink": {
        "emailSubject": "Join our team on AngeonX Sports",
        "emailBody": "Hi, join our team on AngeonX Sports with this invite link:\n\n{{inviteURL}}\n\nIf you need to create an account, use the same link first. After you sign in, AngeonX Sports will take you back to the team invitation automatically.",
        "whatsAppMessage": "Join our team on AngeonX Sports. Open this invite link to sign in or create an account; after sign in, the app will continue to the team invitation automatically: {{inviteURL}}",
        "title": "Manager's Invite Link!",
        "description": "Share this link with the team manager to join the team. If they need to create an account, AngeonX Sports will bring them back to this invitation after sign in. Then the team manager can invite players using the mobile app.",
        "copyLink": "📋 Copy Link",
        "sendEmail": "📧 Send Email",
        "whatsApp": "💬 WhatsApp"
    },
    "teamMemberPicker": {
        "title": "Add {{role}} to team",
        "addCoach": "Add coach",
        "addPlayer": "Add player",
        "roles": {
            "coach": "coach",
            "player": "player"
        },
        "profile": "User profile",
        "searchPlaceholder": "Search user profiles...",
        "add": "Add",
        "alreadyAdded": "Added",
        "loadError": "Failed to load user profiles.",
        "noProfiles": "No user profiles available.",
        "noSearchResults": "No user profiles found for this search.",
        "pageInfo": "Page {{page}} of {{pages}}",
        "addSuccess": "{{role}} added successfully.",
        "addError": "Could not add this member to the team."
    },
    "coordinatorPicker": {
        "title": "Add coordinator to {{name}}",
        "profile": "User profile",
        "searchPlaceholder": "Search user profiles...",
        "add": "Add",
        "alreadyAdded": "Added",
        "loadError": "Failed to load user profiles.",
        "noProfiles": "No user profiles available.",
        "noSearchResults": "No user profiles found for this search.",
        "addSuccess": "Coordinator invited successfully.",
        "addError": "Could not invite this coordinator."
    },
    "playersList": {
        "player": "Player",
        "jerseyNumber": "Jersey number",
        "position": "Position",
        "actions": "Actions",
        "choosePosition": "Choose position",
        "missingProfile": "No active profile selected.",
        "invalidShirtNumber": "Jersey number must be a whole number of 0 or greater.",
        "saveSuccess": "Player updated successfully.",
        "saveError": "Failed to update player.",
        "deleteTitle": "Remove player",
        "deleteMessage": "Are you sure you want to remove {{name}} from this team?",
        "deleteConfirm": "Remove",
        "deleteSuccess": "Player removed successfully.",
        "deleteError": "Failed to remove player."
    },
    "teamCoaches": {
        "deleteTitle": "Remove coach",
        "deleteMessage": "Are you sure you want to remove {{name}} from this team?",
        "deleteConfirm": "Remove",
        "deleteSuccess": "Coach removed successfully.",
        "deleteError": "Failed to remove coach."
    },
    "positions": {
        "soccer": {
            "goalkeeper": "Goalkeeper",
            "defender": "Defender",
            "left-back": "Left Back",
            "right-back": "Right Back",
            "center-back": "Center Back",
            "midfielder": "Midfielder",
            "attacking-midfielder": "Attacking Midfielder",
            "defensive-midfielder": "Defensive Midfielder",
            "winger": "Winger",
            "forward": "Forward",
            "striker": "Striker"
        },
        "baseball": {
            "spare": "Spare",
            "pitcher": "Pitcher",
            "catcher": "Catcher",
            "first-base": "First Base",
            "second-base": "Second Base",
            "third-base": "Third Base",
            "short-stop": "Shortstop",
            "left-fielder": "Left Fielder",
            "centre-fielder": "Center Fielder",
            "right-fielder": "Right Fielder"
        },
        "softball": {
            "spare": "Spare",
            "pitcher": "Pitcher",
            "catcher": "Catcher",
            "first-base": "First Base",
            "second-base": "Second Base",
            "third-base": "Third Base",
            "short-stop": "Shortstop",
            "left-fielder": "Left Fielder",
            "short-fielder": "Short Fielder / Rover",
            "centre-fielder": "Center Fielder",
            "right-fielder": "Right Fielder"
        },
        "basketball": {
            "point-guard": "Point Guard",
            "shooting-guard": "Shooting Guard",
            "small-forward": "Small Forward",
            "power-forward": "Power Forward",
            "center": "Center"
        },
        "american-football": {
            "quarterback": "Quarterback",
            "running-back": "Running Back",
            "fullback": "Fullback",
            "wide-receiver": "Wide Receiver",
            "tight-end": "Tight End",
            "offensive-lineman": "Offensive Lineman",
            "defensive-lineman": "Defensive Lineman",
            "linebacker": "Linebacker",
            "cornerback": "Cornerback",
            "safety": "Safety",
            "kicker": "Kicker",
            "punter": "Punter"
        },
        "hockey": {
            "goalie": "Goalie",
            "defenseman": "Defenseman",
            "left-wing": "Left Wing",
            "right-wing": "Right Wing",
            "center": "Center"
        },
        "rugby": {
            "loosehead-prop": "Loosehead Prop",
            "hooker": "Hooker",
            "tighthead-prop": "Tighthead Prop",
            "lock": "Lock",
            "flanker": "Flanker",
            "number-eight": "Number Eight",
            "scrum-half": "Scrum-half",
            "fly-half": "Fly-half",
            "inside-centre": "Inside Centre",
            "outside-centre": "Outside Centre",
            "wing": "Wing",
            "fullback": "Fullback"
        },
        "volleyball": {
            "outside-hitter": "Outside Hitter",
            "opposite-hitter": "Opposite Hitter",
            "middle-blocker": "Middle Blocker",
            "setter": "Setter",
            "libero": "Libero",
            "defensive-specialist": "Defensive Specialist",
            "serving-specialist": "Serving Specialist"
        }
    },
    addStageModal: {
        badge: "New",
        title: "New Stage",
        createFor: "Create a stage for",
        thisSeason: "this season",
        close: "Close",
        save: "Save",

        fields: {
            stageName: "Stage Name",
            stageType: "Stage Type",
            minGamesRequired: "Minimum games required",
            gameMode: "Game Mode",
            qualifiedTeamsPerGroup: "Qualified teams per group for the next stage",
            additionalTeams: "Additional teams for the next stage"
        },

        placeholders: {
            stageName: "Enter a name for the stage...",
            minGamesRequired: "Enter minimum games required",
            chooseStageType: "Select stage type",
            chooseGameMode: "Select game mode"
        },

        helpers: {
            stageName: "Example: Regular Season, Playoffs, Group A",
            minGamesRequired: "Players must have played at least this number of games to participate in this stage. Leave 0 by default if no games are required.",
            stageType: "Training stages do not require a game mode or qualification rules."
        },

        stageTypes: {
            league: "League",
            roundRobin: "Round Robin",
            brackets: "Playoffs (Bracket)",
            training: "Training Session"
        },

        gameModes: {
            singleGame: "Single Game",
            doubleGame: "Double Game (same day)",
            doubleHeader: "Double Header (second round starts after completing the first round)",
            series3: "Best of 3 (first to 2 wins)",
            series5: "Best of 5 (first to 3 wins)",
            series7: "Best of 7 (first to 4 wins)"
        },

        toasts: {
            createdSuccess: "Stage created successfully",
            minGamesInvalid: "Minimum games required must be a whole number of 0 or greater"
        }
    },
    stageList: {
        title: "Season Stages",
        subtitleManage: "Manage stages for",
        thisSeason: "this season",
        total: "Total",

        headers: {
            stage: "Stage",
            type: "Type",
            actions: "Actions",
        },

        status: {
            completed: "Completed",
            inProgress: "In progress",
            nextStageEnabled: "Next stage enabled",
        },

        labels: {
            scheduleType: "Schedule type",
        },

        actions: {
            openSchedule: "Open schedule",
            advanceTeams: "Advance teams to next stage",
            deleteStage: "Delete stage",
        },

        badges: {
            stageDoneCreateNext: "Stage done · Create next stage",
        },

        toasts: {
            removeSuccess: "Stage removed successfully",
            removeFailed: "Failed to remove stage",
        },

        deleteDialog: {
            title: "Delete this stage?",
            message:
                'You\'re about to remove "{name}".\n\nThis will also remove its games/schedule from this season. This action cannot be undone.\n\nAre you sure?',
            confirm: "Delete Stage",
            cancel: "Cancel",
        },
    },
    confirmDelete: {
        badge: {
            danger: "DANGER",
            confirm: "CONFIRM",
        },
        aria: {
            close: "Close",
        },
        hints: {
            danger: "This action is destructive and may affect related data.",
            confirm: "Please confirm to continue.",
        },
        buttons: {
            working: "Working...",
            delete: "Delete",
            cancel: "Cancel",
            confirm: "Confirm",
        },
        defaults: {
            title: "Are you sure?",
            message: "This action cannot be undone.",
        },
    },
    seasonList: {
        title: "Seasons",
        subtitleManage: "Manage seasons for",
        thisDivision: "this division",

        headers: {
            season: "Season",
            start: "Start",
            end: "End",
            registrationStart: "Registration start date",
            registrationEnd: "Registration end date",
            actions: "Actions",
        },

        labels: {
            seasons: "seasons",
            teamsInSeason: "Teams in this season",
            stagesInSeason: "Stages in this season",
        },

        actions: {
            editSeason: "Edit season",
            deleteSeason: "Delete season",
        },

        toasts: {
            removeSuccess: "Season removed successfully",
            removeFailed: "Failed to remove season",
        },

        deleteDialog: {
            title: "Delete this season?",
            message:
                'You\'re about to delete "{name}".\n\nThis will remove the season from this division. This cannot be undone.\n\nAre you sure?',
            confirm: "Delete Season",
            cancel: "Cancel",
        },
    },
    addSeasonModal: {
        badge: "NEW",
        title: "New Season",

        sections: {
            season: "Season",
            pointSystem: "Point System",
            policies: "Policies",
            registrationFee: "Registration Fee per team",
        },

        fields: {
            name: "Name",
            registrationStartDate: "Registration start date",
            registrationEndDate: "Registration end date",
            lateRegistrationUntil: "Late registration until",
            startDate: "Start date",
            endDate: "End date",
            winPoints: "Win points",
            drawPoints: "Draw points",
            losePoints: "Lose points",
            forfeitWinPoints: "Forfeit win points",
            forfeitLossPoints: "Forfeit loss points",
            forfeitWinScore: "Forfeit win score",
            forfeitLossScore: "Forfeit loss score",
            doubleForfeitPoints: "Double forfeit points",
            overtimeWinPoints: "Overtime win points",
            overtimeLosePoints: "Overtime lose points",
            waiverOptional: "Waiver (optional)",
            feeType: "Fee type",
            lateRegistrationFee: "Late registration fee per player",
            amount: "Amount",
            dueDate: "Due date",
        },

        placeholders: {
            seasonName: "Season name",
            winPoints: "Points when win",
            drawPoints: "Points when draw",
            losePoints: "Points when lose",
            forfeitWinPoints: "Points awarded to the non-forfeiting team",
            forfeitLossPoints: "Points awarded to the forfeiting team",
            forfeitWinScore: "Score assigned to the non-forfeiting team",
            forfeitLossScore: "Score assigned to the forfeiting team",
            doubleForfeitPoints: "Points awarded to each team",
            overtimeWinPoints: "Points when win in overtime",
            overtimeLosePoints: "Points when lose in overtime",
            amountExample: "e.g. 100.00",
            installmentAmountExample: "e.g. 50.00",
        },

        options: {
            noWaiver: "— No waiver —",
            mandatoryOnRegistration: "Generate on registration",
            payLater: "Pay later",
            installments: "Installments",
        },

        toggles: {
            useOvertime: "Use overtime",
            enableRegistrationFee: "Enable registration fee",
        },

        hints: {
            overtime:
                "If enabled, overtime win/loss points can differ from regular time.",
            forfeit:
                "Configure standings points and default scores used by forfeit rules.",
            waiver:
                "Optional waiver that participants must accept when joining.",
            installments:
                "Add one or more installment payments with due dates.",
        },

        buttons: {
            close: "Close",
            save: "Save",
            remove: "Remove",
            addInstallment: "+ Add installment",
        },

        installment: {
            amountNumber: "Amount #{{number}}",
            dueDateNumber: "Due date #{{number}}",
            removeTitle: "Remove installment",
        },

        toast: {
            success: "Season created successfully",
        },
    },
    editSeasonModal: {
        badge: "EDIT",
        title: "Edit Season",
        updateSettingsFor: "Update settings for {{season}}",

        sections: {
            season: "Season",
            pointSystem: "Point System",
            registrationFee: "Registration Fee per team",
        },

        sectionHints: {
            season: "Name and dates",
            pointSystem: "Standings points",
            registrationFee: "Optional fee setup",
            overtime: "Optional OT points",
            forfeit: "Forfeit and double-forfeit rules",
            installments: "Add one or more installments",
        },

        fields: {
            name: "Name",
            registrationStartDate: "Registration start date",
            registrationEndDate: "Registration end date",
            lateRegistrationUntil: "Late registration until",
            startDate: "Start date",
            endDate: "End date",
            waiverOptional: "Waiver (optional)",
            winPoints: "Win Points",
            drawPoints: "Draw Points",
            losePoints: "Lose Points",
            forfeitWinPoints: "Forfeit win points",
            forfeitLossPoints: "Forfeit loss points",
            forfeitWinScore: "Forfeit win score",
            forfeitLossScore: "Forfeit loss score",
            doubleForfeitPoints: "Double forfeit points",
            otWinPoints: "OT Win Points",
            otLossPoints: "OT Loss Points",
            feeType: "Fee type",
            lateRegistrationFee: "Late registration fee per player",
            amount: "Amount",
            dueDate: "Due date",
        },

        placeholders: {
            seasonName: "Season name",
            otWinPoints: "Points for OT win",
            otLossPoints: "Points for OT loss",
            amountExample: "e.g. 100.00",
            installmentAmount: "Amount for #{{number}}",
        },

        options: {
            noWaiver: "— No waiver —",
            none: "None",
            mandatoryOnRegistration: "Generate on registration",
            payLater: "Pay later",
            installments: "Installments",
        },

        toggles: {
            useOvertime: "Use overtime",
            enableRegistrationFee: "Enable registration fee",
        },

        installmentChip: "Installments",

        buttons: {
            close: "Close",
            saveChanges: "Save changes",
            addInstallment: "Add installment",
        },

        titles: {
            removeInstallment: "Remove installment",
        },

        fallback: {
            season: "season",
        },

        validation: {
            atLeastOneInstallment: "At least one installment required.",
            installmentPositiveAmount: "Installment #{{number}} must have a positive amount.",
            installmentDueDate: "Installment #{{number}} must have a due date.",
            registrationFeeRequired: "Registration fee amount and due date required.",
        },

        toast: {
            updated: "Season updated",
        },
    },
    standings: {
        title: "Standings",
        seasonStandings: "Season standings",
        seasonStandingsFor: "Season standings for {{division}}",
        loading: "Loading standings…",
        loadingAria: "Loading standings...",
        empty: "No standings available for this season.",
    },
    baseballStandings: {
        pill: "STANDINGS",
        collapse: "Collapse",
        columns: {
            played: "PG",
            rank: "#",
            team: "Team",
            win: "W",
            lose: "L",
            pct: "PCT",
            gb: "GB",
            rs: "RS",
            ra: "RA",
            diff: "DIFF",
        },
    },
    soccerStandings: {
        pill: "STANDINGS",
        collapse: "Collapse",
        columns: {
            played: "PG",
            rank: "#",
            team: "Team",
            win: "W",
            draw: "D",
            lose: "L",
            goalsFor: "GF",
            goalsAgainst: "GA",
            goalDifference: "GD",
            points: "Pts",
        },
    },
    rugbyStandings: {
        pill: "STANDINGS",
        collapse: "Collapse",
        columns: {
            played: "PG",
            rank: "#",
            team: "Team",
            win: "W",
            draw: "D",
            lose: "L",
            pointsFor: "PF",
            pointsAgainst: "PA",
            difference: "DIFF",
            points: "Pts",
        },
    },
    hockeyStandings: {
        pill: "STANDINGS",
        collapse: "Collapse",
        columns: {
            rank: "#",
            team: "Team",
            played: "GP",
            win: "W",
            lose: "L",
            overtimeLosses: "OTL",
            points: "PTS",
            goalsFor: "GF",
            goalsAgainst: "GA",
            goalDifference: "DIFF",
        },
    },
    sanctions: {
        title: "Sanctions",
        headers: {
            player: "Player",
            game: "Game",
            type: "Type",
            missedGames: "Miss. Games",
            date: "Date",
            actions: "",
        },

        actions: {
            edit: "Edit",
            delete: "Delete",
            close: "Close",
            cancel: "Cancel",
            update: "Update",
            add: "Add",
            saving: "Saving…",
        },

        badge: {
            edit: "EDIT",
            new: "NEW",
        },

        modal: {
            editTitle: "Edit Sanction",
            addTitle: "Add Sanction",
            editSubtitle: "Update this record for the selected player.",
            addSubtitle: "Create a sanction for {{season}}.",
        },

        fields: {
            game: "Game",
            team: "Team",
            player: "Player",
            type: "Type",
            gamesSuspended: "Games Suspended",
            reason: "Reason",
            notes: "Notes",
        },

        options: {
            selectGame: "Select Game",
            selectTeam: "Select Team",
            selectPlayer: "Select Player",
            selectType: "Select type",
        },

        placeholders: {
            gamesSuspended: "0",
            reason: "e.g., Red card, unsportsmanlike conduct…",
            notes: "Optional details…",
            empty: "—",
        },

        toasts: {
            loadError: "Failed to load sanctions",
            updateSuccess: "Sanction updated",
            createSuccess: "Sanction created",
            genericError: "Something went wrong",
            deleted: "Deleted",
            deleteError: "Delete failed",
        },

        deleteConfirm: {
            title: "Delete Sanction",
            message:
                "This sanction will be permanently removed. It will no longer appear on this player's record.\n\nAre you sure you want to continue?",
            confirmLabel: "Yes, delete",
            cancelLabel: "No",
        },

        values: {
            thisSeason: "this season",
        },
        sanctionTypes: {
            fine: "Fine",
            suspension: "Suspension",
        },
    },
    statsDashboard: {
        title: "Stats",
        subtitle: "Leaders and cards for this season{{stageSuffix}}.",
        stageSuffix: " (filtered by stage)",

        plan: {
            pro: "PRO",
            basic: "BASIC",
        },

        sections: {
            leaders: "Leaders",
            cards: "Cards",
            gamesPlayed: "Most Games Played"
        },

        tabsAria: "Stats sections",

        actions: {
            refresh: "Refresh",
        },

        upgrade: {
            title: "Upgrade required.",
            description: "Stats is available on Pro or Elite plans.",
        },

        cards: {
            top10: "Top 10",
            stageFiltered: "Stage filtered",
            seasonTotal: "Season total",
            accumulatedYellowCards: "Accumulated Yellow Cards",
            accumulatedYellowCardsSubtitle: "Yellow cards by player (season totals)",
            failedToLoad: "Failed to load accumulated yellow cards. Try again.",
            yellowsTitle: "{{count}} accumulated yellow cards",
        },

        leaderCards: {
            topScorers: "Top Scorers",
            topAssists: "Top Assists",
            topRedCards: "Top Red Cards",
            topGoalContributions: "Goal Contributions",
            topOwnGoals: "Own Goals",
            hockey_goals: "Top Goal Scorers",
            hockey_assists: "Most Assists",
            hockey_shots: "Most Shots",
            hockey_penalty_minutes: "Penalty Minutes",
            hockey_saves: "Most Saves",
            hockey_hits: "Most Hits",
            hockey_blocked_shots: "Most Blocked Shots",
            hockey_takeaways: "Most Takeaways",
            hockey_giveaways: "Most Giveaways",
            hockey_faceoff_wins: "Most Faceoff Wins",
            hockey_faceoff_losses: "Most Faceoff Losses",
            hockey_shots_against: "Most Shots Faced",
            hockey_goals_against: "Most Goals Allowed",
            hockey_shutouts: "Most Shutouts",
            batting_avg: "Batting Average Leaders",
            hits: "Hit Leaders",
            home_runs: "Home Run Leaders",
            rbi: "RBI Leaders",
            runs_scored: "Runs Scored Leaders",
            strikeouts: "Strikeout Leaders",
            stolen_bases: "Stolen Base Leaders",
            doubles: "Double Leaders",
            triples: "Triple Leaders",
            walks: "Walk Leaders",
            hit_by_pitch: "Hit-by-Pitch Leaders",
            sacrifice_hits: "Sacrifice Hit Leaders",
            caught_stealing: "Caught Stealing Leaders",
            plate_appearances: "Plate Appearance Leaders",
            innings_played: "Innings Played Leaders",
        },

        metrics: {
            goals: "Goals",
            assists: "Assists",
            reds: "Reds",
            goalContributions: "Goals + assists",
            ownGoals: "Own goals",
            yellows: "Yellows",
            value: "Value",
            hockey_goals: "Goals",
            hockey_assists: "Assists",
            hockey_shots: "Shots",
            hockey_penalty_minutes: "Penalty minutes",
            hockey_saves: "Saves",
            hockey_hits: "Hits",
            hockey_blocked_shots: "Blocked shots",
            hockey_takeaways: "Takeaways",
            hockey_giveaways: "Giveaways",
            hockey_faceoff_wins: "Faceoff wins",
            hockey_faceoff_losses: "Faceoff losses",
            hockey_shots_against: "Shots faced",
            hockey_goals_against: "Goals allowed",
            hockey_shutouts: "Shutouts",
            batting_avg: "AVG",
            hits: "Hits",
            home_runs: "Home runs",
            rbi: "RBI",
            runs_scored: "Runs",
            strikeouts: "Strikeouts",
            stolen_bases: "Stolen bases",
            doubles: "Doubles",
            triples: "Triples",
            walks: "Walks",
            hit_by_pitch: "Hit by pitch",
            sacrifice_hits: "Sacrifice hits",
            caught_stealing: "Caught stealing",
            plate_appearances: "Plate appearances",
            innings_played: "Innings played",
        },

        states: {
            loading: "Loading…",
            failedToLoad: "Failed to load. Try again.",
            noData: "No data yet.",
            unavailable: "Unavailable",
            empty: "—",
        },

        table: {
            player: "Player",
            team: "Team",
            yellows: "Yellows",
            gamesPlayed: "Games Played"
        },
        "gamesPlayed": {
            "title": "Most Games Played",
            "subtitle": "Players with the highest number of matches played",
            "failedToLoad": "Failed to load most games played.",
            "stageFiltered": "Stage filtered",
            "seasonTotal": "Season total",
            "gamesTitle": "{{count}} games played"
        }
    },
    adjustment: {
        title: "Point Adjustments",
        subtitle: "Manage adjustments for {{season}}",

        headers: {
            createdAt: "Created At",
            stage: "Stage",
            team: "Team",
            points: "Points",
            reason: "Reason",
            comment: "Comment",
            actions: "Actions",
        },

        badge: {
            edit: "EDIT",
            new: "NEW",
        },

        modal: {
            editTitle: "Edit Adjustment",
            addTitle: "Add Adjustment",
            subtitle: "Update points that affect standings.",
        },

        fields: {
            team: "Team",
            stage: "Stage",
            points: "Points",
            reason: "Reason",
            commentOptional: "Comment (optional)",
        },

        options: {
            selectTeam: "Select a team",
            selectStage: "Select a stage",
            selectReason: "Select reason",
        },

        reasons: {
            fairPlayBonus: "Fair Play Bonus",
            disciplinePenalty: "Discipline Penalty",
            manualAdjustment: "Manual Adjustment",
        },

        actions: {
            edit: "Edit adjustment",
            delete: "Delete adjustment",
            close: "Close",
            cancel: "Cancel",
            saving: "Saving…",
            update: "Update",
            add: "Add",
        },

        deleteConfirm: {
            title: "Delete this adjustment?",
            message:
                "This adjustment will be deleted and the points will no longer affect the standings.\n\nAre you sure you want to continue?",
            confirmLabel: "Delete",
            cancelLabel: "Cancel",
        },

        toasts: {
            loadError: "Failed to load adjustments",
            createdSuccess: "Adjustment created successfully",
            editedSuccess: "Adjustment edited successfully",
            deletedSuccess: "Adjustment deleted successfully",
            genericError: "Something went wrong",
            deleteError: "Delete failed",
        },

        values: {
            thisSeason: "this season",
            empty: "—",
            noComment: "-",
        },
    },
    "fixtures": {
        "title": "Events",
        "headers": {
            "matchweek": "Matchweek",
            "stageGroup": "Stage/Group",
            "away": "Away",
            "home": "Home",
            "score": "Score",
            "details": "Details",
            "actions": "Actions"
        },
        "buttons": {
            "actions": "Actions",
            "addGames": "Add Games",
            "addTrainings": "Add Trainings",
            "bulkEdit": "Bulk Edit",
            "assignReferee": "Assign officials",
            "printSchedule": "Print schedule",
            "printGameSheet": "Print game sheet",
            "downloadGamesTemplate": "Download import template",
            "importGamesExcel": "Import games (Excel)"
        },
        "tooltips": {
            "openPublicSchedule": "Open public schedule and copy link",
            "printOfficialGameSheets": "Select games and print official game sheets",
            "downloadGamesTemplate": "Choose a stage and download the games import template",
            "importGamesExcel": "Upload an Excel file, review rows, and import games"
        },
        "messages": {
            "failedToLoadEvents": "Failed to load events",
            "publicScheduleCopied": "Public schedule link copied to clipboard.",
            "noGamesToPrint": "There are no games to print on this page.",
            "noStagesAvailable": "There are no stages available for this season.",
            "failedToDownloadTemplate": "Could not download games import template.",
            "templateDownloaded": "Games import template downloaded.",
            "excelToolsPlanRequired": "This feature is available only for Elite, Enterprise, or Trial plans.",
            "refereeManagementFeatureRequired": "Referee assignment is available only with the referee management feature."
        },
        "pageSize": {
            "label": "Rows",
            "option": "{{size}} / page"
        },
        "assignmentFilter": {
            "label": "Referee assignments",
            "all": "All games",
            "unassigned": "Unassigned",
            "manual": "Manual",
            "proposed": "Proposed",
            "invited": "Invitation pending",
            "accepted": "Accepted",
            "declined": "Declined",
            "completed": "Completed"
        },
        "templateModal": {
            "title": "Download games import template",
            "stageLabel": "Stage",
            "maxRowsLabel": "Max rows",
            "maxRowsHint": "Number of rows to generate in the template.",
            "selectStage": "Select a stage",
            "download": "Download template",
            "generating": "Generating...",
            "templateTypeLabel": "Template type",
            "blankTemplate": "Plain text blank template",
            "dropdownTemplate": "Pre-filled template with dropdowns",
            "dropdownTemplateHint": "Use this template if you want pre-filled Excel dropdowns, lookup data, and hidden IDs.",
            "blankTemplateHint": "Use this template if you prefer to type names manually and validate them during import."
        },
        "importModal": {
            "rowNumber": "Row",
            "badge": "IMPORT",
            "title": "Import games from Excel",
            "close": "Close",
            "uploadTitle": "Upload completed template",
            "uploadHint": "Accepted formats: .xlsx, .xls",
            "clear": "Clear",
            "previewHint": "Previewing {count} row(s). Fix anything before importing.",
            "rowLabel": "Row {row}:",
            "supportedTemplatesHint": "Supports both the pre-filled template and the plain text template.",
            "detectedTemplateType": "Detected: {type}",
            "dropdownImportType": "Pre-filled template with dropdowns",
            "blankImportType": "Plain text blank template",
            "buttons": {
                "importGames": "Import games",
                "importing": "Importing..."
            },
            "messages": {
                "fileParsed": "File parsed: {count} row(s) ready for review.",
                "importSuccess": "Games imported successfully.",
                "fileParsedWithErrors": "{count} rows loaded with {errors} issues. Please review the highlighted rows."
            },
            "errors": {
                "fixRows": "Please fix the following rows:",
                "completeAllRequired": "Complete all required fields.",
                "teamsMustBeDifferent": "Home and away teams must be different.",
                "onlyExcelFiles": "Only Excel files are allowed (.xlsx, .xls).",
                "emptyWorkbook": "The workbook is empty.",
                "noRowsDetected": "No game rows were detected in the file.",
                "missingColumns": "Missing required columns: {columns}",
                "parseFailed": "Could not parse this Excel file.",
                "importFailed": "Could not import games. {message}",
                "invalidMatchDay": "Matchday must be a valid number.",
                "stageNotFound": "Stage not found: {value}",
                "groupNotFound": "Group not found in this stage: {value}",
                "awayTeamNotFound": "Away team not found in this stage/season: {value}",
                "homeTeamNotFound": "Home team not found in this stage/season: {value}",
                "fieldNotFound": "Venue/field not found in this stage: {value}",
                "refereeNotFound": "Ref/umpire not found: {value}",
                "managerNotFound": "Coordinator not found: {value}",
                "invalidDateTime": "Invalid datetime format. Use yyyy-mm-dd HH:mm."
            }
        }
    },
    "officialAssignmentModal": {
        "badge": "OFFICIALS",
        "title": "Assign officials",
        "subtitle": "Invite officials from each game’s stage pool to confirm coverage.",
        "close": "Close",
        "send": "Send invitations",
        "sending": "Sending...",
        "labels": {"stagePool": "Stage pool", "stagePoolHint": "Only officials in the selected stage pools are shown.", "games": "games", "available": "available", "current": "currently assigned", "selectOfficials": "Officials to invite", "selected": "selected", "noOfficials": "No officials available in this stage pool.", "resend": "Resend", "replace": "Replace", "cancelReplacement": "Cancel replacement", "confirmReplacement": "Confirm replacement", "replacing": "Replacing...", "assignmentHistory": "Assignment history", "referee": "Official", "coordinator": "Coordinator", "multipleHint": "Select one or more officials to invite for this game.", "bulkOfficials": "Officials for this batch", "bulkOfficialsHint": "Select officials once and add them to the selected games. Invitations are sent only when you click Send invitations.", "addBulkOfficials": "Add to selected games", "undoBulkOfficials": "Undo last addition", "searchOfficials": "Search officials", "selectVisible": "Select visible", "clearSelected": "Clear", "removeOfficial": "Remove official", "noBulkOfficialsSelected": "No officials selected", "noBulkOfficialsFound": "No officials found", "plannedInvitations": "invitations to send", "notInStagePool": "not in stage pools", "conflicts": "conflicts", "resolveConflicts": "Resolve schedule conflicts before sending.", "conflict": "Schedule conflict", "conflictHint": "This official is selected for another game at the same time.", "home": "Home team", "away": "Away team", "homeLogo": "Home team logo", "awayLogo": "Away team logo", "gameNumber": "Game {{id}}"},
        "statuses": {"proposed": "Proposed", "invited": "Invited", "accepted": "Accepted", "declined": "Declined", "cancelled": "Cancelled", "completed": "Completed"},
        "messages": {"selectGame": "Select at least one scheduled game.", "selectReferee": "Select at least one official to invite.", "selectBulkOfficial": "Select at least one official for the batch.", "bulkApplied": "Officials applied to the selected games.", "selectReplacement": "Select an eligible replacement official.", "sent": "Official invitations sent successfully.", "partialSent": "Some invitations were sent, but {{count}} could not be sent. Review the remaining selections.", "resent": "Official invitation resent successfully.", "replaced": "Replacement official invitation sent successfully.", "failed": "Could not send official invitations."}
    },
    "bulkEditGamesModal": {
        "title": "Bulk Edit Events",
        "selectedCount": "{{count}} selected event(s).",
        "field": "Field",
        "referees": "Officials",
        "managers": "Coordinator",
        "description": "Description",
        "descriptionPlaceholder": "Enter description...",
        "noChange": "No change",
        "save": "Save Changes",
        "noEventsSelected": "Please select at least one scheduled event.",
        "failed": "Failed to update selected events.",
        "failedToResolveMatching": "Failed to load matching events for bulk update.",
        "success": "{{count}} event(s) updated successfully.",
        "applyToAllMatching": "Apply to all scheduled events in this season",
        "applyToAllMatchingHint": "This applies changes to matching scheduled events across all pages.",
        "validation": {
            "selectAtLeastOneChange": "Select at least one change before saving."
        }
    },
    "event": {
        "new": {
            "form": {
                "responsible": "Ref/Ump(s)",
                "managers": "Coordinator(s)"
            }
        }
    },
    "gameElement": {
        "matchweekLabel": "GAME · MATCHWEEK {{matchDay}}",
        "emptyValue": "—",
        "noGame": "No-game",
        "scheduled": "Scheduled",
        "locationLabel": "Location: {{value}}",
        "coachLabel": "Coach: {{value}}",
        "managerLabel": "Coordinator: {{value}}",
        "refereeUmpireLabel": "Officials: {{value}}",
        "actions": "Actions",
        "more": "More",
        "toggleDropdown": "Toggle Dropdown",
        "enterResult": "Enter Result",
        "enterDetails": "Game Details",
        "enterInnings": "Enter Innings",
        "editGame": "Edit Game",
        "deleteGame": "Delete Game",
        "addSanction": "Add Sanction",
        "visitorLogoAlt": "Visitor Logo",
        "homeLogoAlt": "Home Logo",
        "penaltiesShort": "pens",
        "messages": {
            "gameRemovedSuccessfully": "Game removed successfully",
            "failedToRemoveGame": "Failed to remove game"
        },
        "confirmDelete": {
            "title": "Delete this game?",
            "message": "You're about to delete:\n{{visitorName}} @ {{homeName}}\n\nThis game will be permanently removed from this stage.\n\nAre you sure?",
            "confirmLabel": "Delete Game",
            "cancelLabel": "Cancel"
        },
        "soccerGameSheet": {
            "title": "Game Details",
            "visitorShort": "VISITOR",
            "homeShort": "HOME",
            "teamLabel": "Team",
            "select": "Select",
            "noEvents": "No events yet",
            "loading": "Loading...",
            "form": {
                "addEvent": "Add Event",
                "save": "Save",
                "saving": "Saving..."
            },
            "fields": {
                "team": "Team",
                "eventType": "Event Type",
                "player": "Player",
                "relatedPlayer": "Related Player (optional)",
                "minute": "Minute",
                "period": "Period",
                "notes": "Notes (optional)"
            },
            "validation": {
                "required": "Please complete all required fields"
            },
            "toasts": {
                "saveSuccess": "Event saved successfully",
                "saveFailed": "Failed to save event",
                "deleteSuccess": "Event deleted successfully"
            },
            "eventTypes": {
                "goal": "Goal",
                "assist": "Goal pass",
                "substitutionIn": "Subbed In",
                "substitution_out": "Subbed Out",
                "yellow_card": "Yellow Card",
                "red_card": "Red Card",
                "own_goal": "Own Goal"
            },
            "proDetailedResultsRequired": "This feature requires a Pro subscription plan or higher.",
            "timeline": "Timeline"
        },
        "hockeyGameSheet": {
            "title": "Hockey Game Details",
            "visitor": "Visitor",
            "home": "Home",
            "visitorShort": "VISITOR",
            "homeShort": "HOME",
            "gameFeed": "GAME FEED",
            "eventEntry": "EVENT ENTRY",
            "timeline": "Timeline",
            "allPeriods": "All",
            "periodLabel": "Period {{period}}",
            "periodShort": "P{{period}}",
            "overtimeShort": "OT{{period}}",
            "overtimeLabel": "Overtime",
            "shootoutLabel": "Shootout",
            "noEventsInPeriod": "No events in this period.",
            "penaltyMinutesSummary": "{{minutes}} penalty minutes",
            "relatedPlayerSummary": "Related: {{player}}",
            "closeAria": "Close hockey game details",
            "addEvent": "Add game event",
            "noEvents": "No events yet.",
            "loading": "Loading hockey events...",
            "loadFailed": "Unable to load hockey events.",
            "team": "Team",
            "action": "Action",
            "player": "Player",
            "relatedPlayer": "Related player",
            "optional": "optional",
            "period": "Period",
            "minute": "Minute",
            "second": "Second",
            "penaltyType": "Penalty type",
            "penaltyMinutes": "Penalty minutes",
            "notes": "Notes",
            "select": "Select",
            "optionalSelect": "Optional",
            "saveEvent": "Save event",
            "saving": "Saving...",
            "close": "Close",
            "delete": "Delete event",
            "confirmDeleteTitle": "Delete hockey event?",
            "confirmDeleteMessage": "Delete the {{action}} event in period {{period}} at {{time}}? This cannot be undone.",
            "confirmDeleteConfirm": "Delete event",
            "confirmDeleteCancel": "Keep event",
            "required": "Complete the team, player, action, period, and minute fields.",
            "invalidPeriod": "Period must be a whole number greater than zero.",
            "invalidMinute": "Each period is 20 minutes. Enter a time from 0:00 through 20:00.",
            "invalidSecond": "Seconds must be a whole number from 0 to 59.",
            "saveSuccess": "Hockey event saved successfully.",
            "eventTypes": {
                "goal": "Goal",
                "assist": "Assist",
                "shot": "Shot",
                "penalty": "Penalty",
                "faceoff_win": "Faceoff win",
                "faceoff_loss": "Faceoff loss",
                "hit": "Hit",
                "blocked_shot": "Blocked shot",
                "takeaway": "Takeaway",
                "giveaway": "Giveaway",
                "save": "Save",
                "goal_against": "Goal against",
                "substitution_in": "Substitution in",
                "substitution_out": "Substitution out"
            },
            "penaltyTypes": {
                "minor": "Minor",
                "major": "Major",
                "misconduct": "Misconduct",
                "game_misconduct": "Game misconduct",
                "match": "Match"
            }
        }
    },
    "trainingElement": {
        "type": "TRAINING",
        "scheduled": "Scheduled",
        "trainingSession": "Training Session",
        "noTeams": "No teams",
        "noParticipants": "No participants",
        "emptyValue": "—",
        "teamsCount": "Teams: ({{count}})",
        "participantsCount": "Participants: ({{count}})",
        "locationLabel": "Location: {{value}}",
        "coachLabel": "Coach: {{value}}",
        "actions": "Actions",
        "more": "More",
        "toggleDropdown": "Toggle Dropdown",
        "deleteSession": "Delete Session",
        "showParticipants": "Show participants",
        "hideParticipants": "Hide participants",
        "messages": {
            "removedSuccessfully": "Training session removed successfully",
            "failedToDelete": "Failed to delete training session"
        },
        "confirmDelete": {
            "title": "Delete this session?",
            "message": "You're about to delete this training session.\n\nThis action cannot be undone.\n\nAre you sure?",
            "confirmLabel": "Delete Session",
            "cancelLabel": "Cancel"
        }
    },
    "bulkAddGamesModal": {
        "bulk": "BULK",
        "title": "Bulk Add Games",
        "close": "Close",
        "choose": "Choose",
        "notAvailable": "N/A",
        "teamFallback": "Team",
        "headers": {
            "stage": "Stage",
            "group": "Group",
            "description": "Description",
            "datetime": "Datetime",
            "away": "Away",
            "home": "Home",
            "venue": "Venue",
            "responsible": "Ref/Ump",
            "manager": "Coordinator",
            "matchday": "Matchday"
        },
        "placeholders": {
            "description": "Description"
        },
        "alerts": {
            "fixFollowing": "Please fix the following:",
            "rowLabel": "Row {{row}}:"
        },
        "validation": {
            "completeAllFields": "Please complete all fields.",
            "teamsMustBeDifferent": "Home and visitor teams must be different."
        },
        "messages": {
            "gamesCreatedSuccessfully": "Games created successfully!",
            "errorCreatingGames": "Error creating games: {{message}}"
        },
        "buttons": {
            "addAnotherGame": "Add another game",
            "saveAll": "Save All",
            "saving": "Saving..."
        },
        "hint": "Tip: use consistent matchdays to keep scheduling clean.",
        "matchdayOption": "Matchday {{matchDay}}",
        "matchdayNewOption": "Matchday {{matchDay}} (new)",
        "removeRow": "Remove row"
    },
    "bulkAddTrainingsModal": {
        "bulk": "BULK",
        "title": "Bulk Add Trainings",
        "close": "Close",
        "choose": "Choose",
        "notAvailable": "N/A",
        "headers": {
            "stage": "Stage",
            "group": "Group",
            "datetime": "Datetime",
            "teams": "Teams",
            "venue": "Venue",
            "responsibleCoach": "Responsible/Coach"
        },
        "alerts": {
            "fixFollowing": "Please fix the following:",
            "rowLabel": "Row {{row}}:"
        },
        "validation": {
            "completeAllFields": "Please complete all fields.",
            "selectAtLeastOneTeam": "Select at least one team."
        },
        "messages": {
            "trainingsCreatedSuccessfully": "Training sessions created successfully!",
            "errorCreatingTrainings": "Error creating trainings: {{message}}"
        },
        "buttons": {
            "addAnotherTraining": "Add another training",
            "saveAll": "Save All",
            "saving": "Saving..."
        },
        "helpText": "Hold Ctrl/Cmd to select multiple teams.",
        "hint": "Tip: you can select multiple teams per session.",
        "removeRow": "Remove row"
    },
    "printGameSheetsModal": {
        "title": "Select games to print",
        "noGamesAvailable": "No games available to print.",
        "selectAll": "Select all",
        "unselectAll": "Unselect all",
        "selectedCount": "Selected: {{selected}} / {{total}}",
        "headers": {
            "dateTime": "Date / Time",
            "field": "Field",
            "match": "Match"
        },
        "fallbacks": {
            "home": "Home",
            "away": "Visitor",
            "emptyValue": "—"
        },
        "vs": "vs",
        "close": "Close",
        "printGames": "Print {{count}} game",
        "printGames_plural": "Print {{count}} games"
    },
    "gameSheet": {
        "fallbacks": {
            "organization": "Organization",
            "homeTeam": "Home team",
            "awayTeam": "Away team",
            "emptyValue": "—",
            "match": "Match"
        },
        "matchweekLabel": "Matchweek {{matchDay}}",
        "header": {
            "division": "Division",
            "season": "Season",
            "stageGroup": "Stage/Group",
            "date": "Date",
            "time": "Time",
            "field": "Field",
            "location": "Location"
        },
        "teams": {
            "away": "Away",
            "home": "Home"
        },
        "score": {
            "finalScore": "Final score"
        },
        "notes": {
            "weather": "Weather",
            "category": "Category",
            "pageHint": "* Use the second page to record incidents, goals, plays and sanctions."
        },
        "rosters": {
            "awayRoster": "Away roster",
            "homeRoster": "Home roster",
            "number": "#",
            "player": "Player",
            "position": "Pos",
            "starter": "Starter",
            "notes": "Notes"
        },
        "officials": {
            "title": "Officials",
            "refereeCrewChief": "Referee / Crew chief",
            "assistantUmpire1": "Assistant / Umpire 1",
            "assistantUmpire2": "Assistant / Umpire 2",
            "fourthOfficialUmpire3": "4th official / Umpire 3",
            "scorerTableOfficial": "Scorer / Table official",
            "timekeeper": "Timekeeper",
            "otherOfficials": "Other officials"
        },
        "incidents": {
            "title": "Incidents / goals / plays",
            "timeSegment": "Time / Inning / Set / Quarter",
            "team": "Team",
            "player": "# / Player",
            "eventDescription": "Event / Description"
        },
        "signatures": {
            "title": "Signatures",
            "awayRepresentative": "Away representative",
            "homeRepresentative": "Home representative",
            "refereeCrewChief": "Referee / Crew chief",
            "leagueRepresentativeOptional": "League representative (optional)",
            "commentsProtests": "Comments / protests"
        }
    },
    "publicSchedulePage": {
        "meta": {
            "schedule": "Schedule",
            "seasonSchedule": "Season Schedule",
            "pageTitleSuffix": "AngeonX Sports",
            "descriptionWithTitle": "Official schedule for {{title}}. View games, trainings and events updated in real time.",
            "defaultDescription": "Official season schedule powered by AngeonX Sports. View live games, trainings and competitions."
        },
        "header": {
            "lastUpdated": "Last updated: {{value}}",
            "share": "Share",
            "printSchedule": "Print schedule"
        },
        "sections": {
            "seasonSchedule": "Season schedule",
            "liveScheduleDescription": "This is the live schedule for this season. Any changes made by organization staff will automatically appear here. You can print this view or share the link with teams and families.",
            "readOnlyNote": "This schedule is read-only. The official, always up-to-date version lives inside AngeonX Sports. If you print this, please check this page for last-minute changes."
        },
        "loading": {
            "title": "Loading season schedule..."
        },
        "error": {
            "title": "Schedule not available"
        },
        "shareMessages": {
            "copied": "Link copied to clipboard.",
            "copyFailed": "Copy failed. You can copy the URL from the address bar.",
            "copyPrompt": "Copy this link:"
        },
        "table": {
            "headers": {
                "dateTime": "Date & Time",
                "type": "Type",
                "matchSession": "Match / Session",
                "stageGroup": "Stage / Group",
                "field": "Field",
                "responsible": "Responsible",
                "scoreStatus": "Score / Status"
            },
            "empty": "No events scheduled yet."
        },
        "eventTypes": {
            "game": "Game",
            "training": "Training",
            "competition": "Competition",
            "event": "Event"
        },
        "eventLabels": {
            "teams": "Teams: {{teams}}",
            "trainingSession": "Training session",
            "competition": "Competition",
            "event": "Event",
            "visitor": "Visitor",
            "home": "Home",
            "scheduled": "Scheduled",
            "emptyValue": "—"
        },
        "print": {
            "footer": "Official schedule • Generated from AngeonX Sports • {{url}}",
            "watermark": "AngeonX Sports Schedule"
        }
    },
    "editGameModal": {
        "edit": "EDIT",
        "title": "Edit Game",
        "close": "Close",
        "save": "Save",
        "labels": {
            "stage": "Stage",
            "datetime": "Datetime",
            "description": "Description",
            "visitorTeam": "Visitor Team",
            "homeTeam": "Home Team",
            "facilityField": "Facility/Field",
            "coach": "Coach",
            "refereeUmpire": "Officials",
            "notInStagePool": "not in stage pool",
            "manager": "Coordinator"
        },
        "placeholders": {
            "chooseStage": "Choose stage",
            "enterDatetime": "Enter datetime ...",
            "enterDescription": "Enter description ...",
            "chooseVisitorTeam": "Choose visitor team",
            "chooseHomeTeam": "Choose home team",
            "chooseField": "Choose field",
            "chooseRefereeUmpire": "Choose referee/umpire",
            "chooseManager": "Choose coordinator"
        },
        "helpText": {
            "stageLocked": "Stage is locked for editing."
        },
        "messages": {
            "gameModifiedSuccessfully": "Game modified successfully"
        },
        "validation": {
            "conflictOn": "{{name}} on {{date}} at {{field}}"
        }
    },
    "gameResultModal": {
        "result": "RESULT",
        "title": "Game Result",
        "close": "Close",
        "save": "Save",
        "headers": {
            "team": "Team",
            "score": "Score"
        },
        "labels": {
            "status": "Event status",
            "forfeitTeam": "Forfeiting team",
            "resetIndividualStats": "Reset individual stats",
            "penaltyShootout": "Penalty shootout"
        },
        "hockey": {
            "resultType": "Result type",
            "regulation": "Regulation",
            "overtime": "Overtime",
            "shootout": "Shootout",
            "resultTypeHint": "Use overtime or shootout only when the game was decided after regulation.",
            "sections": {
                "teamStats": "Team statistics",
                "scoring": "Scoring and shots",
                "goalkeeping": "Goalkeeping",
                "discipline": "Discipline and physical play",
                "home": "Home",
                "visitor": "Visitor"
            },
            "stats": {
                "shotsOnGoal": "Shots on goal", "powerPlayGoals": "Power-play goals", "powerPlayOpportunities": "Power-play opportunities",
                "saves": "Saves", "penaltyMinutes": "Penalty minutes", "hits": "Hits", "blockedShots": "Blocked shots",
                "homeShotsOnGoal": "Home shots on goal", "awayShotsOnGoal": "Visitor shots on goal",
                "homePenaltyMinutes": "Home penalty minutes", "awayPenaltyMinutes": "Visitor penalty minutes",
                "homeSaves": "Home saves", "awaySaves": "Visitor saves",
                "homePowerPlayGoals": "Home power-play goals", "awayPowerPlayGoals": "Visitor power-play goals",
                "homePowerPlayOpportunities": "Home power-play opportunities", "awayPowerPlayOpportunities": "Visitor power-play opportunities",
                "homeHits": "Home hits", "awayHits": "Visitor hits",
                "homeBlockedShots": "Home blocked shots", "awayBlockedShots": "Visitor blocked shots"
            }
        },
        "teams": {
            "visitor": "Visitor",
            "home": "Home"
        },
        "aria": {
            "visitorScore": "Visitor score",
            "homeScore": "Home score",
            "eventStatus": "Event status",
            "forfeitTeam": "Forfeiting team",
            "visitorPenalties": "Visitor penalty shootout score",
            "homePenalties": "Home penalty shootout score"
        },
        "options": {
            "selectForfeitTeam": "Select team"
        },
        "validation": {
            "selectForfeitTeam": "Select the team that forfeited.",
            "penaltyScoresRequired": "Enter both penalty shootout scores.",
            "penaltyWinnerRequired": "Penalty shootout scores must produce a winner."
        },
        "scheduledStatusWarningWithIndividualStats": "Warning: If the game is saved as Scheduled, global stats and individual stats will be reset.",
        "scheduledStatusWarningWithoutIndividualStats": "Warning: If the game is saved as Scheduled, global stats will be reset. Individual stats will not be reset unless selected.",
        "hint": "Tip: Enter final scores only. You can edit later while the game remains scheduled/in progress.",
        "messages": {
            "gameResultAddedSuccessfully": "Game result added successfully"
        }
    },
    "baseballScore": {
        "badge": "INNINGS",
        "title": "Inning Scorecard",
        "subtitle": "Record runs inning by inning",
        "visitor": "Visitor",
        "home": "Home",
        "final": "Final score",
        "extended": "Extended score",
        "scorecard": "Scorecard",
        "runsShort": "Runs",
        "team": "Team",
        "hint": "Enter runs for innings that have been played. Leave future innings at zero.",
        "inning": "Inning",
        "total": "R",
        "addInning": "Add inning",
        "save": "Save scorecard",
        "cancel": "Cancel",
        "close": "Close",
        "saving": "Saving...",
        "messages": {"saved": "Inning score saved successfully", "saveFailed": "Failed to save inning score"}
    },
    "gameSanctionModal": {
        "new": "NEW",
        "title": "Add Sanction",
        "subtitle": "Create a sanction for {{season}}.",
        "fallbacks": {
            "season": "this season",
            "visitor": "Visitor",
            "home": "Home"
        },
        "labels": {
            "team": "Team",
            "player": "Player",
            "type": "Type",
            "gamesSuspended": "Games Suspended",
            "reason": "Reason",
            "notes": "Notes",
            "matchweek": "Matchweek {{value}}"
        },
        "placeholders": {
            "selectTeam": "Select Team",
            "selectPlayer": "Select Player",
            "selectType": "Select type",
            "gamesSuspended": "0",
            "reason": "e.g., Red card, unsportsmanlike conduct…",
            "notes": "Optional details…"
        },
        "types": {
            "suspension": "Suspension"
        },
        "buttons": {
            "close": "Close",
            "cancel": "Cancel",
            "add": "Add",
            "saving": "Saving…"
        },
        "messages": {
            "requiredFields": "Please complete required fields.",
            "created": "Sanction created",
            "failed": "Failed to create sanction"
        }
    },
    stageDetail: {
        nav: {
            schedule: "Schedule",
            organizations: "Organizations",
            divisions: "Divisions",
            divisionShort: "Div",
        },

        labels: {
            coaches: "Coaches",
            refereesOrUmpires: "Officials",
            groups: "Groups",
            date: "Date",
            venues: "Venues",
            availableFields: "Available Fields",
            selectedFields: "Selected Fields",
        },

        dualList: {
            venuesTitle: "Venues",
            venuesDescription: "Choose the venues for this stage",
        },

        buttons: {
            createSchedule: "Create Schedule",
            cancel: "Cancel",
            processing: "Processing...",
        },

        confirm: {
            title: "Confirm Schedule Generation",
            message:
                "You are about to generate the whole schedule using the Groups/Teams, Venues, Dates and Referees configured.\n\nDo you want to continue?",
        },

        alerts: {
            somethingWentWrong: "Something went wrong",
            scheduleCreated: "Schedule created successfully",
            failedToCreateSchedule: "Failed to create schedule",

            tabGroupsErrorTitle: "Tab Groups Error.",
            tabGroupsErrorMessage: "Please create groups first.",

            tabDateErrorTitle: "Tab Date Error.",
            tabDateErrorMessage: "Please select at least one day.",

            tabVenuesErrorTitle: "Tab Venues Error.",
            tabVenuesErrorMessage: "Please select at least one field.",

            scheduleErrorTitle: "Schedule Error.",
            scheduleErrorMessage:
                "You can't create schedule for stages with games having results entered.",
        }
    },
    groupsList: {
        header: {
            title: "Groups & Teams",
            subtitle: "Draft teams into groups for {{seasonName}}",
            fallbackSeason: "this season",
        },

        info: {
            teamsInStage: "Teams in this stage",
            teamsCount: "{{count}} teams",
            scheduleType: "Schedule type",
            emptyValue: "—",
        },

        sections: {
            draftTools: "Draft tools",
            draftToolsDescription:
                "Randomly assign teams marked as todo across existing groups, or restart the draft.",
            groups: "Groups",
            groupsDescription: "Create and manage groups for this stage.",
        },

        buttons: {
            randomDraft: "Random Draft",
            restartDraft: "Restart Draft",
        },

        tooltips: {
            randomDraft: "Randomly draft teams into groups",
            restartDraft: "Restart draft (remove teams from groups)",
        },

        alerts: {
            createGroupsFirst: "Please create groups first",
            addTeamGroupError: "Failed to add teams to groups",
            cleanGroupsError: "Failed to clean groups",
        },

        emptyState: {
            createGroupsFirst: "Create groups first",
            createGroupsFirstDescription:
                "Use the Groups panel to create your group structure before drafting.",
        },
    },
    listTeams: {
        section: {
            title: "Groups and Teams",
            subtitle: "Drag teams into groups. Use checkboxes to bulk-remove from a group.",
        },

        containers: {
            teams: "Teams",
            noUnassignedTeams: "No unassigned teams",
            dropTeamsHere: "Drop teams here",
            teamsListAria: "Teams list",
            groupDropZoneAria: "Group drop zone",
        },

        buttons: {
            removeSelected: "Remove selected",
            deleteGroup: "Delete group",
        },

        confirm: {
            deleteGroupTitle: "Delete this group?",
            deleteGroupMessage:
                "Teams in this group will be moved back to the Teams list.\n\nAre you sure you want to continue?",
            deleteGroupConfirmLabel: "Delete Group",
            cancel: "Cancel",
        },

        status: {
            unassigned: "Unassigned",
            assignedToGroup: "Assigned to group",
        },

        toasts: {
            addingTeamToGroup: "Adding team to group…",
            failedToRemoveTeamFromGroup: "Failed to remove team from group",
            failedToAddTeamToGroup: "Failed to add team to group",
            failedToRemoveTeams: "Failed to remove team(s)",
            failedToDeleteGroup: "Failed to delete group",
        },

        misc: {
            drag: "Drag",
        },
    },
    createGroup: {
        labels: {
            groupName: "Group name",
            poolName: "Pool name",
            gameName: "Game name",
        },

        placeholders: {
            groupName: "Group name",
            poolName: "Pool name",
            gameName: "Game name",
        },

        buttons: {
            createGroup: "Create Group",
            createPool: "Create Pool",
            createGame: "Create Game",
        },

        nouns: {
            group: "Group",
            pool: "Pool",
            game: "Game",
        },

        hints: {
            tip: "Tip: Create all {{itemName}} first, then use {{randomDraft}} to distribute teams. If your phase is a league structure, create a single group with all teams.",
            randomDraft: "Random Draft",
        },

        toasts: {
            createdSuccessfully: "{{noun}} created successfully",
            onlyOnePoolAllowed: "Only one pool is allowed",
            failedToCreate: "Failed to create {{noun}}",
        },
    },
    stagePlayDaysList: {
        header: {
            title: "Available Days & Times",
            subtitle: "Timing windows for games in this stage",
            addDay: "Add Day",
            addDayTitle: "Add a day/time window",
        },

        table: {
            day: "Day",
            time: "Time",
            actions: "Actions",
            weeklySlot: "Weekly slot",
            fromTime: "From time",
            deleteDayTime: "Delete day/time",
        },

        confirm: {
            deleteTitle: "Delete this day/time?",
            deleteMessage:
                "You're about to remove:\n\n{{dayName}} at {{fromTime}}\n\nThis will affect schedule generation for this stage. This action cannot be undone.",
            delete: "Delete",
            cancel: "Cancel",
        },

        days: {
            monday: "Monday",
            tuesday: "Tuesday",
            wednesday: "Wednesday",
            thursday: "Thursday",
            friday: "Friday",
            saturday: "Saturday",
            sunday: "Sunday",
            selectedDay: "Selected day",
        },
    },
    addStagePlayDayModal: {
        header: {
            title: "Add Day & Time",
            subtitle: "Define a playable day/time window for this stage",
            close: "Close",
        },

        fields: {
            day: "Day",
            time: "Time",
            chooseDay: "Choose a day",
            enterTime: "Enter time...",
        },

        buttons: {
            close: "Close",
            save: "Save",
            saving: "Saving...",
        },

        helper: {
            tip: "Tip: pick consistent time slots (e.g., 18:00) to simplify scheduling and reduce conflicts.",
        },

        toasts: {
            addedSuccessfully: "Day and time added successfully",
            somethingWentWrong: "Something went wrong",
            stageRequired: "Stage not found. Please refresh and try again.",
            dayRequired: "Please choose a day",
            timeRequired: "Please choose a time",
            invalidDay: "Invalid day selected",
        },

        days: {
            monday: "Monday",
            tuesday: "Tuesday",
            wednesday: "Wednesday",
            thursday: "Thursday",
            friday: "Friday",
            saturday: "Saturday",
            sunday: "Sunday",
        },
    },
    dualListSelector: {
        defaults: {
            title: "Select Items",
            description: "Choose items from the list",
            leftTitle: "Available",
            rightTitle: "Selected",
        },

        search: {
            placeholder: "Search...",
        },

        labels: {
            available: "Available",
            selected: "Selected",
        },

        buttons: {
            add: "Add",
            remove: "Remove",
        },

        empty: {
            noItemsFound: "No items found.",
            noItemsSelected: "No items selected.",
        },

        hints: {
            searchByVenueOrField: "Tip: search by venue name or field name.",
            selectedItemsUsedForStage: "Selected items will be used for this stage.",
        },

        titles: {
            add: "Add",
            remove: "Remove",
        },
    },
    refereeList: {
        roles: {
            coaches: "Coaches",
            refereesOrUmpires: "Officials",
        },

        header: {
            chooseForStage: "Choose the {{role}} for this stage",
        },

        sections: {
            available: "Available {{role}}",
            selected: "Selected {{role}}",
        },

        search: {
            placeholder: "Search {{role}}...",
        },

        labels: {
            rating: "Rating",
        },

        buttons: {
            add: "Add",
            remove: "Remove",
        },

        empty: {
            noRoleFound: "No {{role}} found.",
            noRoleSelected: "No {{role}} selected.",
        },

        helper: {
            availableTip:
                "Tip: add {{role}} on the left; they will appear in “Selected”.",
            selectedTip:
                "Selected {{role}} will be used for scheduling and assignment in this stage.",
        },

        actions: {
            remove: "remove",
        },
    },
    errorPage: {
        meta: {
            title: "AngeonX Sports – Page not found",
        },

        brand: {
            platform: "AngeonX Sports Platform",
            pageNotFound: "Page not found",
        },

        content: {
            title404: "404",
            description:
                "The page you are looking for doesn't exist or the link is no longer valid.",
        },

        reasons: {
            typo: "The URL may have a typo.",
            movedOrRemoved: "The page may have been moved or removed.",
            outdatedLink: "An old link might be pointing to an outdated location.",
        },

        buttons: {
            backToHome: "Back to home",
            goBack: "Go back",
        },

        help: {
            internalAppIssue:
                "If this keeps happening from inside the app, please let your league or organization admin know so they can check the link.",
            quickTips: "Quick tips",
            navTip:
                "Use the main navigation to access your leagues, schedules and games.",
            inviteTip:
                "If you opened an invite or shared link, make sure it hasn't expired or been changed.",
            needHelp: "Need help or found a broken link?",
            supportText:
                "For support with AngeonX Sports and other AngeonX products, you can reach us at:",
            productLine: "AngeonX Sports™ is a product of AngeonX Inc.",
        },
    },
    verifyEmail: {
        meta: {
            title: "AngeonX Sports – Email Verification",
        },

        brand: {
            namePrimary: "kBola",
            nameSecondary: "Sports",
            logoAlt: "kBola Sports",
        },

        content: {
            title: "Email Verification",
            readyForSignIn: "Your account is ready for Sign In!!!",
        },

        status: {
            verifying: "Verifying...",
            verifiedSuccess:
                "✅ Your email has been verified! You can now log in to AngeonX Sports.",
            unknownError: "An unknown error occurred.",
            genericError: "⚠️ Something went wrong. Please try again.",
            accountAlreadyVerified: "Account already verified.",
        },

        actions: {
            openApp: "Open AngeonX Sports app",
            continueWeb: "Continue to web login",
        },
    },
    deleteAccount: {
        meta: {
            title: "AngeonX Sports – Delete Account",
        },

        brand: {
            namePrimary: "kBola",
            nameSecondary: "Sports",
            logoAlt: "kBola Sports",
        },

        content: {
            title: "Delete Your Account",
            intro:
                "You can delete your AngeonX Sports account anytime directly from the mobile app:",
        },

        steps: {
            openApp: "Open the app",
            goSettings: "Go to More → Settings",
            tapDelete: 'Tap "Delete Account"',
        },

        help: {
            emailIntro:
                "If you can't access the app, email us at",
            emailInstruction:
                "from your registered email address with your deletion request.",
            processingTime: "We’ll process your request within 7 days.",
        },

        actions: {
            backToLogin: "Back to Login",
        },
    },
    marketplaceRedirect: {title: "Open this listing in AngeonX Sports", description: "Continue in the AngeonX Sports mobile app to view this marketplace listing.", openApp: "Open in the app", invalid: "This listing link is not valid.", noApp: "If the app did not open, install it here:", ios: "iPhone / iPad", android: "Android"},
    inviteRedirect: {
        meta: {
            title: "AngeonX Sports – Opening App",
        },

        brand: {
            namePrimary: "kBola",
            nameSecondary: "Sports",
            logoAlt: "kBola Sports",
        },

        content: {
            title: "Opening the App...",
            description:
                "If nothing happens, you'll be redirected to install the app shortly.",
        },
    },
    successPage: {
        meta: {
            title: "AngeonX Sports – Subscription Success",
        },

        brand: {
            namePrimary: "kBola",
            nameSecondary: "Sports",
            logoAlt: "kBola Sports",
        },

        content: {
            title: "Subscription created successfully!!!",
            description: "Your new subscription plan is ready to use!!!",
        },
    },
    cancelPage: {
        meta: {
            title: "AngeonX Sports – Subscription Cancelled",
        },

        brand: {
            namePrimary: "kBola",
            nameSecondary: "Sports",
            logoAlt: "kBola Sports",
        },

        content: {
            title: "Subscription cancelled successfully!!!",
        },
    },
    passwordReset: {
        meta: {
            title: "AngeonX Sports – Reset Password",
        },

        brand: {
            namePrimary: "kBola",
            nameSecondary: "Sports",
            logoAlt: "kBola Sports",
        },

        content: {
            title: "Reset Password",
        },

        fields: {
            newPassword: "New Password",
            confirmNewPassword: "Confirm New Password",
        },

        buttons: {
            resetPassword: "Reset Password",
            resetting: "Resetting...",
            close: "Close",
        },

        status: {
            success: "✅ Your password has been reset! You can now log in.",
        },

        errors: {
            title: "Errors",
            enterAndConfirmPassword: "Please enter and confirm your new password.",
            passwordsDoNotMatch: "Passwords do not match.",
            unknownError: "An unknown error occurred.",
            somethingWentWrong: "⚠️ Something went wrong. Please try again.",
        },
    },
    publicEventPage: {
        meta: {
            siteName: "AngeonX Sports",
            defaultDescription: "Official event details powered by AngeonX Sports.",
            locale: "en_CA",
            eventFallback: "Event",
            loadingTitle: "Loading event...",
            notFoundTitle: "Event not found",
        },

        loading: {
            details: "Loading event details...",
        },

        error: {
            title: "Event not found",
            description: "This event may have been removed or is no longer available.",
        },

        breadcrumb: {
            events: "Events",
        },

        status: {
            final: "Final",
            live: "Live",
            cancelled: "Cancelled",
            upcoming: "Upcoming",
            scheduled: "Scheduled",
            completed: "Completed",
            inProgress: "In Progress",
        },

        sections: {
            event: "Event",
            eventOverview: "Event overview",
            photos: "Photos",
        },

        labels: {
            home: "Home",
            away: "Away",
            timeline: "Timeline",
            lineups: "Lineups",
            stats: "Stats",
            dateTime: "Date & time",
            venue: "Venue",
            competition: "Competition",
            eventType: "Event type",
            locationMap: "Location map",
            googleMaps: "Google Maps",
            rating: "Rating",
            gameSummary: "Game summary",
            eventTypeFallback: "EVENT",
            teamFallback: "Team",
        },

        timeline: {
            emptyTitle: "No timeline events published yet.",
            emptyDescription: "Check back closer to game time or in the AngeonX Sports app.",
        },

        lineups: {
            title: "Lineups are managed inside AngeonX Sports.",
            description: "Download the app to view official lineups and changes in real time.",
        },

        stats: {
            title: "Stats for this event will appear here.",
            description: "Keep tracking in AngeonX Sports to unlock full player and team stats.",
        },

        photos: {
            open: "Open photo",
            close: "Close photo",
            previous: "Previous photo",
            next: "Next photo",
            photoAlt: "Event photo",
        },
    },
    advertisePage: {
        meta: {
            title: "AngeonX Sports – Advertise",
        },

        hero: {
            title: "Get Your Brand In Front of Players, Parents, and Teams",
            description1:
                "AngeonX Sports is where leagues, tournaments, and academies manage their games, schedules, rosters, stats, and communication.",
            description2:
                "Your business can appear right where they spend their time — inside the app.",
            bullet1:
                "Show your brand inside the AngeonX Sports app — just like a featured card.",
            bullet2:
                'Tap-to-open button (“See more”) that drives people to your promo or site.',
            bullet3:
                "Optional expanded view with your full message and graphic.",
            bullet4:
                "Target by sport (soccer, baseball, softball, etc.).",
            pricing:
                "Ad spots start at $99/week. No long-term contract.",
            createSponsorAccount: "Create Sponsor Account",
            alreadyHaveAccount: "Already have an account?",
            signIn: "Sign in",
        },

        preview: {
            logoPlaceholder: "Your Logo",
            cardTitle: "Your Business — Get more players, clients, or customers",
            cardText:
                "“Train with the best coaches in the city. Limited spots this month…”",
            viewMore: "View more",
            seeMore: "See more",
            sponsoredPlacement: "Sponsored placement inside AngeonX Sports",
            expandedTitle: "Full-Screen Highlight",
            expandedSubtitle: "(Your Brand Feature)",
            expandedHeadline: "Your Headline — Stand out to the right audience",
            expandedText:
                "This is where you tell your full story: your camp, your clinic, your service, your store. Users can tap to learn more, register, or contact you.",
            expandedFooter: "Example of expanded sponsor view in the app",
        },

        howItWorks: {
            title: "How It Works",
            step1Title: "1. Create Your Sponsor Account",
            step1Text:
                "Tell us who you are and what you offer. This gives you access to your Sponsor Dashboard.",
            step2Title: "2. Launch Your Campaign",
            step2Text:
                "Upload your banner, choose the sport (soccer, baseball, etc.), pick your dates, and checkout with a card.",
            step3Title: "3. Get Seen in the App",
            step3Text:
                "Your ad shows in AngeonX Sports to players, parents, and coaches. You’ll be able to see views and clicks.",
        },

        faq: {
            whoIsThisForTitle: "Who is this for?",
            whoIsThisForText:
                "Training academies, local businesses, sports clinics, physiotherapy, recovery products, tournaments, merch, camps, private coaches — anyone who wants visibility in youth and amateur sports.",
            longContractTitle: "Do I need a long contract?",
            longContractText:
                "No. You can run a short campaign for a week. Perfect for camps with limited dates or promos with deadlines.",
        },

        finalCta: {
            createSponsorAccount: "Create Sponsor Account",
            alreadySponsor: "Already a sponsor?",
            signIn: "Sign in",
        },
    },
    notificationsPage: {
        page: {
            title: "Notifications",
            inbox: "Inbox",
            subtitle: "{{count}} notification{{suffix}} for {{name}}",
        },

        tabs: {
            label: "Notification views",
            received: "Received",
            sent: "Sent",
        },

        table: {
            headers: {
                sender: "Sender",
                title: "Title",
                message: "Message",
                type: "Type",
                created: "Created",
                actions: "Actions",
            },
            notificationFallback: "Notification",
            systemSender: "System",
            emptyType: "—",
            read: "Read",
            unread: "Unread",
            rating: "Rating",
        },

        actions: {
            markAsRead: "Mark as read",
            alreadyRead: "Already read",
            read: "Read",
            delete: "Delete",
            deleteAll: "Delete all",
            markAllAsRead: "Mark all as read",
            refresh: "Refresh",
            noActions: "No actions",
        },

        bulk: {
            markAllAsReadTitle: "Mark all notifications as read",
            deleteAllTitle: "Delete all notifications",
            refreshTitle: "Refresh",
        },

        confirmations: {
            markAllTitle: "Mark all as read",
            markAllMessage:
                "This will mark all notifications as read for your active profile. Continue?",
            markAllConfirm: "Mark all as read",
            deleteAllTitle: "Delete all notifications",
            deleteAllMessage:
                "This will permanently delete all notifications for your active profile. Continue?",
            deleteAllConfirm: "Delete all",
        },

        toasts: {
            missingActiveProfile: "Missing active profile.",
            missingNotificationId: "Missing notification id.",
            failedMarkRead: "Failed to mark as read.",
            failedDelete: "Failed to delete notification.",
            failedMarkAllRead: "Failed to mark all as read.",
            failedDeleteAll: "Failed to delete all notifications.",
            markedRead: "Marked as read.",
            couldNotMarkRead: "Could not mark as read.",
            deleted: "Deleted.",
            couldNotDelete: "Could not delete notification.",
            allMarkedRead: "All notifications marked as read.",
            couldNotMarkAllRead: "Could not mark all as read.",
            allDeleted: "All notifications deleted.",
            couldNotDeleteAll: "Could not delete all notifications.",
            failedSend: "Failed to send notification.",
            sentCreated: "Sent. Created {{count}} notifications.",
            sendFailed: "Send failed.",
            titleRequired: "Title is required.",
            messageRequired: "Message is required.",
            selectOrganization: "Please select an organization.",
        },

        compose: {
            allDivisions: "All divisions",
            allSeasons: "All seasons",
            allTeams: "All teams",
            selectedCount: "{{count}} selected",
            audienceManagersOnly: "Managers only",
            audienceRefereesOnly: "Referees only",
            audienceEveryone: "Everyone (Managers, Referees, Players)",
            orgFallback: "Org",
            divisionFallback: "Division",
        },

        row: {
            unreadTitle: "Unread",
            readTitle: "Read",
            sentTitle: "Sent",
        },
    },
    notificationFiltersBar: {
        header: {
            title: "Filters",
            subtitle: "Narrow results by status and type, then click Apply",
        },

        actions: {
            compose: "Compose",
            reset: "Reset",
            apply: "Apply",
        },

        tooltips: {
            compose: "Compose new notification",
            reset: "Reset filters",
            apply: "Apply filters",
        },

        fields: {
            status: "Status",
            typeSingleSelect: "Types (Single-select: click to choose, click again to clear)",
            filterByStatus: "Filter by status",
            filterByType: "Filter by type",
        },

        statusOptions: {
            all: "All",
            unread: "Unread",
            read: "Read",
        },

        empty: {
            noTypesAvailable: "No notification types available.",
        },
    },
    notificationTypes: {
        chat: "Chat",
        event: "Event",
        gamification: "Gamification",
        notification: "Notification",
        invite: "Invite",
        payment: "Payment",
        rate: "Ratings",
        result: "Result",
        team: "Team",
        organization: "Organization",
        link: "Link",
    },
    notificationComposeDrawer: {
        header: {
            title: "Compose",
            subtitle: "Draft a new notification and segment recipients",
            close: "Close",
        },

        recipientBar: {
            previewTitle: "Recipient segmentation preview",
            org: "Org:",
            division: "Division:",
            season: "Season:",
            teams: "Teams:",
            recipients: "Recipients:",
        },

        fields: {
            title: "Title",
            titlePlaceholder: "e.g., Schedule update",
            message: "Message",
            messagePlaceholder: "Write your message…",
            recipients: "Recipients",
            organization: "Organization",
            division: "Division",
            season: "Season",
            teamsMulti: "Teams (multi-select)",
        },

        recipients: {
            everyone: "Everyone (Managers, Referees, Players)",
            managersOnly: "Team managers only",
            refereesOnly: "Umpires/Referees only",
        },

        hints: {
            recipients:
                "This controls which roles receive the notification within the selected segmentation.",
            teams:
                "Select one or more teams, or leave empty for all.",
            teamsDisabled:
                "Teams selection is disabled when audience is set to Referees.",
        },

        actions: {
            cancel: "Cancel",
            send: "Send",
            sending: "Sending...",
        },

        labels: {
            all: "All",
            selectedCount: "{{count}} selected",
        },
    },
    "subscriptionLimit": {
        "organization_limit_reached": "Your organization subscriptions allow only {{limit}} {{item}}. Upgrade your subscription to create more.",
        "limit_reached": "Your subscription limit has been reached. Upgrade your subscription to continue.",
        "planLimit": "Your current plan ({{currentPlan}}) allows only {{limit}} {{itemLabel}}. Upgrade subscription to unlock more.",
        "feature_required": "This feature is not available on your current subscription. Upgrade your subscription to continue."
    },
    "organizationDivisionSummary": {
        "loading": "Loading organization summary...",
        "error": "Unable to load organization summary.",
        "noData": "No data available yet.",
        "title": "Organization Overview",
        "subtitle": "Summary across divisions, active seasons, teams, players, and games.",
        "seasonProgress": "Season Progress",
        "cards": {
            "divisions": "Divisions",
            "activeSeasons": "Active Seasons",
            "teams": "Teams",
            "players": "Players",
            "games": "Games",
            "completed": "Completed",
            "scheduled": "Scheduled",
            "issues": "Issues"
        },
        "hints": {
            "openDivisions": "{{count}} open",
            "currentlyRunning": "Currently running",
            "registeredTeams": "Registered teams",
            "registeredPlayers": "Registered players",
            "completedGames": "{{count}} completed",
            "finishedGames": "Finished games",
            "upcomingPending": "Upcoming/pending",
            "postponedCancelled": "Cancelled"
        },
        "charts": {
            "teamsByDivision": {
                "title": "Teams by Division",
                "subtitle": "Top divisions by registered teams"
            },
            "playersByDivision": {
                "title": "Players by Division",
                "subtitle": "Top divisions by registered players"
            },
            "gamesByStatus": {
                "title": "Games by Status",
                "subtitle": "Current operational state"
            }
        },
        "chartLabels": {
            "teams": "Teams",
            "players": "Players"
        },
        "status": {
            "completed": "Completed",
            "scheduled": "Scheduled",
            "pending": "Pending",
            "open": "Open",
            "postponed": "Postponed",
            "cancelled": "Cancelled",
            "done": "Done",
            "finished": "Finished",
            "unknown": "Unknown"
        }
    },
    advertisingDashboard: {
        "United States": "United States",
        "Canada": "Canada",
        "All Statuses": "All Statuses",
        "Running": "Running",
        "Paused": "Paused",
        "Ended": "Ended",
        "Draft": "Draft",
        "Archived": "Archived",
        "Pending Payment": "Pending Payment",
        "Active": "Active",
        "Inactive": "Inactive",
        "Scheduled": "Scheduled",
        "Completed": "Completed",
        "Canceled": "Canceled",
        "Cancelled": "Cancelled",
        "Expired": "Expired",
        noAdvertisingDataForPeriod: "No advertising data for this period.",
        "No advertising data for this period.": "No advertising data for this period.",
        "Campaign Details": "Campaign Details",
        "Campaign": "Campaign",
        "Sponsor": "Sponsor",
        "Status": "Status",
        "Impressions": "Impressions",
        "Clicks": "Clicks",
        "CTR": "CTR",
        "CPM": "CPM",
        "CPC": "CPC",
        "Budget": "Budget",
        "Spent": "Spent",
        "Advertising": "Advertising",
        "Dashboard": "Dashboard",
        "All Sponsors": "All Sponsors",
        "All Campaigns": "All Campaigns",
        "All Screens": "All Screens",
        "All Countries": "All Countries",
        "Start Date": "Start Date",
        "End Date": "End Date",
        "Screen": "Screen",
        "Country": "Country",
        "Reset": "Reset",
        "Unable to load advertising analytics.": "Unable to load advertising analytics.",
        "Loading advertising analytics...": "Loading advertising analytics...",
        "Total ad views": "Total ad views",
        "Total ad clicks": "Total ad clicks",
        "Click-through rate": "Click-through rate",
        "Cost per thousand impressions": "Cost per thousand impressions",
        "Cost per click": "Cost per click",
        "Campaigns": "Campaigns",
        "active": "active",
        "Paid": "Paid",
        "Confirmed ad orders": "Confirmed ad orders",
        "remaining": "remaining",
        "Tracked campaign spend": "Tracked campaign spend",
        "Daily Performance": "Daily Performance",
        "Traffic By Country": "Traffic By Country",
        "Traffic By Screen": "Traffic By Screen",
        "Traffic By Ad Zone": "Traffic By Ad Zone",
        "Creative Performance": "Creative Performance",
        "Campaign Performance": "Campaign Performance",
        performanceOverview: "Performance overview for your advertising campaigns.",
        "Performance overview for your advertising campaigns.": "Performance overview for your advertising campaigns."
    },
    advertisingAudience: {
        advertising: "Advertising",
        audience: "Audience",
        description: "Audience estimates for planning advertising campaigns.",
        scopedDescription: "Audience estimates reflect users your campaigns can reach under Enterprise protection rules.",
        staffDescription: "Staff view shows all active platform users by default. Filters narrow the dashboard by sport, organization, or location.",
        sport: "Sport",
        league: "Organization",
        city: "City",
        state: "State / Province",
        country: "Country",
        allSports: "All Sports",
        allLeagues: "All Organizations",
        allVisibleLeagues: "All visible leagues",
        cityPlaceholder: "Any city",
        statePlaceholder: "All states/provinces",
        countryPlaceholder: "All countries",
        selectCountryFirst: "Select country first",
        reset: "Reset",
        loadError: "Unable to load audience estimates.",
        loading: "Loading audience estimates...",
        activePeriod: "Active Period",
        last7Days: "Last 7 Days",
        last30Days: "Last 30 Days",
        last3Months: "Last 3 Months",
        last6Months: "Last 6 Months",
        last1Year: "Last 1 Year",
        totalUsers: "Total Users",
        totalUsersHint: "Reachable platform users",
        reachableUsers: "Reachable users",
        reachableUsersHint: "Filtered by your organization ad scope",
        staffTotalUsersHint: "All active platform users",
        staffAllUsersNotice: "Staff mode: this dashboard is using the full active-user audience unless you apply filters.",
        activeUsers: "Active Users",
        newUsers: "New Users",
        active7Days: "Active 7 Days",
        active7DaysHint: "Recently active users",
        active30Days: "Active 30 Days",
        active30DaysHint: "Monthly active users",
        newUsersOverTime: "New Users Over Time",
        audienceBySport: "Audience By Sport",
        visibleLeagueAudience: "Visible League Audience",
        topLeagues: "Top Organizations",
        noAudienceData: "No audience data available.",
        noLeagueData: "No organization audience data available."
    },
    sponsors: {
        advertising: "Advertising",
        sponsors: "Sponsors",
        deleteSponsor: "Delete Sponsor",
        deleteConfirmMessage: "Are you sure you want to delete \"{name}\"?\nThis cannot be undone.",
        delete: "Delete",
        cancel: "Cancel",
        deleteError: "Error deleting sponsor.",
        deleteCouldNot: "Could not delete sponsor.",
        deleteSuccess: "Successfully deleted sponsor.",
        headers: {
            name: "Name",
            contactName: "Contact Name",
            contactEmail: "Contact Email",
            active: "Active",
            actions: "Actions"
        },
        sport: "Sport",
        billing: "Billing",
        activeBadge: "Active",
        inactiveBadge: "Inactive",
        editSponsor: "Edit sponsor",
        deleteSponsorTitle: "Delete sponsor",
        form: {
            newBadge: "NEW",
            editBadge: "EDIT",
            newSponsor: "New Sponsor",
            editSponsor: "Edit Sponsor",
            close: "Close",
            save: "Save",
            saving: "Saving...",
            sponsorBusinessName: "Sponsor / Business Name",
            contactName: "Contact Name",
            contactEmail: "Contact Email",
            websiteLandingUrl: "Website / Landing URL",
            primarySport: "Primary Sport",
            selectSport: "Select sport…",
            multipleGeneralSports: "Multiple / General Sports",
            billingCountryOptional: "Billing Country (optional)",
            billingCurrencyOptional: "Billing Currency (optional)",
            useProfileDefault: "Use profile default",
            useProfileCountryDefault: "Use profile/country default",
            useBackendDefault: "Use backend default",
            unitedStatesUs: "United States (US)",
            canadaCa: "Canada (CA)",
            notesInternalOnly: "Notes (internal only)",
            notesPlaceholder: "Billing contact, special pricing, etc.",
            activeSponsor: "Active sponsor (can run campaigns)",
            toast: {
                createError: "Error creating sponsor.",
                createCouldNot: "Could not create sponsor.",
                created: "Sponsor created successfully!",
                updateError: "Error updating Sponsor",
                updated: "Sponsor updated successfully!"
            }
        }
    },
    campaigns: {
        advertising: "Advertising",
        campaigns: "Campaigns",
        newCampaign: "New Campaign",
        editCampaign: "Edit Campaign",
        deleteCampaign: "Delete Campaign",
        deleteConfirmMessage: "You're about to permanently delete the campaign \"{name}\".\n\nThis will immediately stop it from serving ads.\n\nAre you sure you want to continue?",
        deleteConfirmLabel: "Yes, delete",
        cancelLabel: "No",
        campaignDeleted: "Campaign deleted",
        failedToDelete: "Failed to delete campaign",
        allCountries: "All Countries",
        allPlatforms: "All Platforms",
        allSports: "All Sports",
        noZones: "No zones",
        zonesCount: "{count} zones",
        headers: {
            name: "Name",
            status: "Status",
            sponsor: "Sponsor",
            dates: "Dates",
            targeting: "Targeting",
            actions: "Actions"
        },
        zones: "Zones",
        start: "Start",
        end: "End",
        geo: "Geo",
        platform: "Platform",
        sport: "Sport",
        loading: "Loading...",
        notFound: "Campaign not found.",
        status: {
            running: "Running",
            paused: "Paused",
            ended: "Ended",
            draft: "Draft",
            archived: "Archived",
            pending_payment: "Pending Payment",
            active: "Active",
            inactive: "Inactive",
            scheduled: "Scheduled",
            completed: "Completed",
            canceled: "Canceled",
            cancelled: "Cancelled",
            expired: "Expired"
        },
        countries: {
            US: "United States",
            CA: "Canada"
        },
        platforms: {
            ios: "iOS",
            android: "Android"
        }
    },
    checkout: {
        paymentSuccess: "Payment Success",
        paymentReceived: "Payment received",
        paymentSuccessMessage: "Your campaign payment was completed successfully. It will be activated once webhook confirmation is processed.",
        openReview: "Open campaign review",
        campaignList: "Campaign list",
        backToCampaigns: "Back to campaigns",
        checkoutCanceled: "Checkout Canceled",
        checkoutCanceledMessage: "No charges were made. You can edit your campaign and try again.",
        openDraft: "Open draft",
        backToReview: "Back to review"
    },
    campaignReview: {
        notFound: "Campaign not found.",
        addPlacement: "Add at least one placement before checkout.",
        couldNotCreateSession: "Could not create checkout session.",
        checkoutFailed: "Checkout failed.",
        errorLoading: "Error loading campaign",
        reviewConfirm: "Review & Confirm",
        edit: "Edit",
        campaign: "Campaign",
        billingCurrency: "Billing currency",
        placements: "Placements",
        countries: "Countries",
        platforms: "Platforms",
        sports: "Sports",
        organizations: "Organizations",
        all: "All",
        total: "Total",
        calculatedOnStripe: "Final amount is calculated on Stripe ({currency})",
        enterpriseMarketplaceNoPaymentRequired: "Included with your Enterprise league subscription",
        calculatedAtCheckout: "Calculated at checkout",
        backToEdit: "Back to Edit",
        redirecting: "Redirecting...",
        confirmPay: "Confirm & Pay",
        beforeYouPay: "Before you pay",
        tip1: "Confirm placements and dates.",
        tip2: "Ensure your creative meets size and content guidelines.",
        tip3: "Taxes are calculated automatically on Stripe.",
        tip4: "Currency is locked to sponsor billing settings.",
        footerText: "Review your details, then continue to Stripe to pay."
    },
    campaignForm: {
        collapse: "Collapse",
        expand: "Expand",
        filePicker: "File picker",
        chooseFile: "Choose file",
        existingImage: "Existing image",
        existingImageLower: "existing image",
        noFileSelected: "No file selected",
        dragDropHint: "Drag & drop a square logo here (PNG/JPG). Recommended 1:1.",
        remove: "Remove",
        logoPreview: "Logo preview",
        preview: "Preview",
        basics: "Basics",
        campaignName: "Campaign Name",
        campaignNamePlaceholder: "Fall Soccer Tryouts - Toronto",
        sponsorBrand: "Sponsor / Brand",
        selectSponsor: "Select sponsor",
        inactive: "(inactive)",
        billingCurrency: "Billing Currency",
        billingCurrencyHint: "Locked to sponsor billing settings.",
        placement: "Placement",
        placementHint: "Where will your ad appear?",
        placementFallback: "Placement",
        targeting: "Targeting",
        targetingHint: "Who should see your campaign?",
        countries: "Countries",
        countryUnitedStates: "United States",
        countryCanada: "Canada",
        geoTargeting: "Geo targeting",
        platforms: "Platforms",
        sportsAudienceFocus: "Sports / Audience Focus",
        audienceSignal: "Audience signal",
        allSportsUncheckedHint: "Leaving all sports unchecked means “all sports”.",
        specificOrganizationsOptional: "Specific Organizations (optional)",
        leagueTournament: "League / Tournament",
        scheduleBudget: "Schedule & Budget",
        startDate: "Start Date",
        endDate: "End Date",
        missingRatesFor: "Missing rates for",
        estimatedTotal: "Estimated total",
        estimatedTotalShort: "Est. total",
        basedOnPlacementsCountriesDuration: "Based on placements, countries and duration",
        days: "days",
        missingRatesLabel: "Missing rates",
        finalPriceHint: "Final price shown at checkout before you pay. Your ad won’t run until payment is confirmed.",
        creative: "Creative",
        creativeHint: "What users will see.",
        brandLogoSquare: "Brand / Logo (square)",
        recommendedRatio: "Recommended: 1:1 ratio, PNG or JPG",
        headline: "Headline",
        headlinePlaceholder: "Elite Winter Soccer Clinic - Limited Spots",
        bodyPitch: "Body / Pitch",
        bodyPitchPlaceholder: "Train with licensed coaches. Ages 10-16. Toronto sessions start Nov 5.",
        ctaButtonLabel: "CTA Button Label",
        ctaButtonLabelPlaceholder: "Register Now",
        ctaUrl: "CTA URL",
        ctaUrlPlaceholder: "https://myacademy.com/tryouts",
        campaignSummary: "Campaign Summary",
        name: "Name",
        sponsor: "Sponsor",
        currency: "Currency",
        placements: "Placements",
        selected: "selected",
        sports: "Sports",
        all: "All",
        dates: "Dates",
        yourLogo: "Your Logo",
        yourLogoFirst: "Your",
        yourLogoSecond: "Logo",
        logo: "Logo",
        yourBusinessCardTitle: "Your Business — Get more players, clients, or customers",
        trainWithBestCoaches: "Train with the best coaches in the city. Limited spots this month.",
        viewMore: "View more",
        sponsoredPlacement: "Sponsored placement inside AngeonX Sports",
        fullScreenHighlight: "Full-Screen Highlight",
        yourBrandFeature: "(Your Brand Feature)",
        yourHeadline: "Your Headline — Stand out to the right audience",
        fullStoryText: "This is where you tell your full story: your camp, your clinic, your service, your store. Users can tap to learn more, register, or contact you.",
        exampleExpandedView: "Example of expanded sponsor view in the app",
        seeMore: "See more",
        editingDraft: "Editing draft...",
        unsavedChanges: "Unsaved changes",
        cancel: "Cancel",
        saving: "Saving...",
        saveDraft: "Save Draft",
        saveChanges: "Save Changes",
        reviewConfirm: "Review & Confirm",
        type: "Type",
        campaignReach: "Campaign reach",
        standardCampaign: "Standard sponsor or league campaign",
        standardCampaignHint: "Uses normal paid or Enterprise organization rules.",
        internalCampaign: "Internal AngeonX Sports campaign",
        internalCampaignHint: "Visible to every eligible user, including Enterprise organizations.",
        internalCampaignReachHint: "This internal campaign can reach users across all organizations. Organization targeting is not used.",
        enterpriseOrganizationTargetingHint: "Enterprise league managers can target any managed organization. Leave empty for a paid global sponsor campaign.",
        enterprisePlan: "Enterprise plan",
        managedOrganization: "Managed organization",
        internalCampaignIncluded: "Internal AngeonX Sports campaigns do not require Stripe payment.",
        enterpriseCampaignIncluded: "Organization-targeted campaigns are included with the Enterprise plan. No Stripe payment is required.",
        enterpriseMarketplaceIncluded: "This marketplace promotion is included with your Enterprise league subscription. No Stripe payment is required.",
        enterpriseMarketplaceIncludedShort: "Included with Enterprise league",
        marketplacePromotion: "Marketplace promotion",
        internalIncludedShort: "Internal campaign",
        enterpriseIncludedShort: "Included with Enterprise",
        organizationCampaign: "Organization campaign",
        globalSponsorCampaign: "Global sponsor campaign",
        allUsers: "All users",
        global: "Global",
        moreItems: "+{count} more",
        platformOptions: {
            ios: "iOS",
            android: "Android"
        },
        adZones: {
            events_banner: { name: "Events Screen Banner", description: "Banner to show on Events Screen" },
            roster_banner: { name: "Roster Screen Banner", description: "Banner to show on Roster Screen" },
            marketplace_banner: { name: "Connect Screen Banner", description: "Banner to show on Connect Screen" },
            payments_banner: { name: "Payments Screen Banner", description: "Banner to show on Payments Screen" },
            more_banner: { name: "More Screen Banner", description: "Banner to show on More Screen" },
            profiles_banner: { name: "Profiles Screen Banner", description: "Banner to show on Profiles Screen" },
            event_details_banner: { name: "Event Details Screen Banner", description: "Banner to show on Event Details Screen" },
            event_result_banner: { name: "Event Result Screen Banner", description: "Banner to show on Event Result Screen" },
            standing_banner: { name: "Standing Screen Banner", description: "Banner to show on Standing Screen" },
            edit_team_player_banner: { name: "Roster Edit Player Screen Banner", description: "Banner to show on Roster Edit Player Screen" },
            stats_banner: { name: "Stats Screen Banner", description: "Banner to show on Stats Screen" },
            kbs_fantasy_banner: { name: "kBs Fantasy Banner", description: "Banner to show on kBs Fantasy Screen" },
            preferences_banner: { name: "Preferences Banner", description: "Banner to show on Preferences Screen" },
            add_profile_banner: { name: "Add Profile Banner", description: "Banner to show on Add Profile Screen" },
            add_team_banner: { name: "Add Team Banner", description: "Banner to show on Add Team Screen" },
            edit_team_banner: { name: "Edit Team Banner", description: "Banner to show on Edit Team Screen" },
            organizations_banner: { name: "Organizations Screen Banner", description: "Banner to show on Organizations Screen" },
            organization_banner: { name: "Organization Detail Screen Banner", description: "Banner to show on Organization Detail Screen" },
            divisions_banner: { name: "Divisions Screen Banner", description: "Banner to show on Divisions Screen" },
            division_banner: { name: "Division Detail Screen Banner", description: "Banner to show on Division Detail Screen" },
            division_team_players_banner: { name: "Division Team Players Screen Banner", description: "Banner to show on Division Team Players Screen" },
            division_teams_add_player_banner: { name: "Division Team Add Players Screen Banner", description: "Banner to show on Division Team Add Players Screen" },
            kbs_challenges_banner: { name: "kBs Fantasy Challenges Banner", description: "Banner to show on kBs Fantasy Challenges Screen" },
            chat_list_banner: { name: "Chat List Screen Banner", description: "Banner to show on Chat List Screen" },
            leaders_banner: { name: "Leaders Screen Banner", description: "Banner to show on Leaders Screen" },
            marketplace_listings_banner: { name: "Marketplace Listings Screen Banner", description: "Banner to show on Marketplace Listings Screen" },
            marketplace_listing_banner: { name: "Marketplace Listing Detail Screen Banner", description: "Banner to show on Marketplace Listing Detail Screen" },
            marketplace_favorites_banner: { name: "Marketplace Favorites Screen Banner", description: "Banner to show on Marketplace Favorites Screen" },
            marketplace_my_listings_banner: { name: "My Marketplace Listings Screen Banner", description: "Banner to show on My Marketplace Listings Screen" },
            marketplace_blocked_users_banner: { name: "Marketplace Blocked Users Screen Banner", description: "Banner to show on Marketplace Blocked Users Screen" },
            referee_assignments_banner: { name: "Referee Assignments Screen Banner", description: "Banner to show on Referee Assignments Screen" },
            referee_availability_banner: { name: "Referee Availability Screen Banner", description: "Banner to show on Referee Availability Screen" },
            subscription_banner: { name: "Subscription Screen Banner", description: "Banner to show on Subscription Screen" },
            invoices_banner: { name: "Invoices Screen Banner", description: "Banner to show on Invoices Screen" },
            notifications_banner: { name: "Notifications Screen Banner", description: "Banner to show on Notifications Screen" },
            team_events_banner: { name: "Team Events Screen Banner", description: "Banner to show on Team Events Screen" },
            team_stats_banner: { name: "Team Stats Screen Banner", description: "Banner to show on Team Stats Screen" },
            event_photos_banner: { name: "Event Photos Screen Banner", description: "Banner to show on Event Photos Screen" },
            event_referee_rating_banner: { name: "Event Referee Rating Screen Banner", description: "Banner to show on Event Referee Rating Screen" },
            memory_game_banner: { name: "Memory Game Screen Banner", description: "Banner to show on Memory Game Screen" },
            player_fight_banner: { name: "Player Fight Screen Banner", description: "Banner to show on Player Fight Screen" },
            rate_player_banner: { name: "Rate Player Screen Banner", description: "Banner to show on Rate Player Screen" },
            marketplace_rating_list_banner: { name: "Marketplace Rating List Screen Banner", description: "Banner to show on Marketplace Rating List Screen" },
            send_notification_banner: { name: "Send Notification Screen Banner", description: "Banner to show on Send Notification Screen" },
            player_profile_banner: { name: "Player Profile Screen Banner", description: "Banner to show on Player Profile Screen" },
            player_insights_banner: { name: "Player Insights Screen Banner", description: "Banner to show on Player Insights Screen" },
            referee_profile_banner: { name: "Referee Profile Screen Banner", description: "Banner to show on Referee Profile Screen" },
            referee_assignment_detail_banner: { name: "Referee Assignment Detail Screen Banner", description: "Banner to show on Referee Assignment Detail Screen" },
            referee_rating_comments_banner: { name: "Referee Rating Comments Screen Banner", description: "Banner to show on Referee Rating Comments Screen" }
        },
        toast: {
            enterNameSponsorPlacement: "Please enter name, select a sponsor, and choose at least one placement.",
            missingRates: "Missing rates for selected zone/country in sponsor currency.",
            provideImage: "Please provide one image (upload or URL).",
            couldNotSaveDraft: "Could not save draft:",
            unknownError: "Unknown error",
            draftSaved: "Draft saved!",
            somethingWentWrongSaving: "Something went wrong saving your draft.",
            missingCampaignId: "Missing campaign id.",
            completeRequiredFields: "Please complete the required fields.",
            updateFailed: "Update failed:",
            draftUpdated: "Draft updated!",
            somethingWentWrongUpdating: "Something went wrong updating your draft.",
            couldNotProceedToReview: "Could not proceed to review.",
        }
    }
};

export default en;
